define([], function () {

    const BRAND = 'Huawei Cloud';

    var framework = {
        "title.error": "เกิดข้อผิดพลาด",
        "title.prompt": "ข้อมูล",
        "title.confirm": "ยืนยัน",
        "title.warn": "คำเตือน",
        "hasBindUniportal": "บัญชี Huawei Cloud ของคุณได้รับการอัปเกรดแล้ว ใช้ HUAWEI ID ของคุณเพื่อเข้าสู่ระบบ",
        "mobileLoginModel.intlIpTip": "ใช้หมายเลขโทรศัพท์ที่ลงทะเบียนในแผ่นดินใหญ่จีนเพื่อเข้าสู่หน้านี้",
        "mobileLoginModel.mobileLogin": "ลงชื่อเข้าใช้ด้วยหมายเลขโทรศัพท์",
        "mobileLoginModel.accountLogin": "ลงชื่อเข้าใช้ด้วยบัญชี/อีเมล",
        "mobileLoginModel.mobilePlaceHolder": "หมายเลขโทรศัพท์",
        "mobileLoginModel.accountPlaceHolder": "ชื่อบัญชีหรืออีเมล",
        "mobileLoginModel.userPlaceHolder": "ชื่อผู้ใช้ IAM หรืออีเมล",
        "mobileLoginModel.notRegisterTip": "มายเลขโทรศัพท์ที่ไม่ได้ลงทะเบียน",
        "mobileLoginModel.isMobileTip": "ดูเหมือนว่าคุณได้ป้อนหมายเลขโทรศัพท์ ต้องการเปลี่ยนเป็น",
        "mobileLoginModel.registerNow": "สมัครเลย",
        "mobileLoginModel.multiUsersTip": "มายเลขโทรศัพท์ผูกไว้กับหลายบัญชี โปรดเลือกบัญชีที่ต้องการใช้",
        "mobileLoginModel.operationTooFrequent": "คุณลองหลายครั้งเกินไป โปรดลองใหม่ในภายหลัง {0} นาที",
        "mobileLoginModel.invalidNumber": "โปรดป้อนหมายเลขโทรศัพท์ที่ถูกต้อง",
        "mobileLoginModel.retry": "โปรดลองอีกครั้ง",
        "mobileLoginModel.retrievePwd": "รีเซ็ตรหัสผ่าน",
        "emailLoginModel.multiUsersTip": "ที่อยู่อีเมลถูกผูกไว้กับหลายบัญชี เลือกบัญชีที่คุณต้องการใช้",
        "fpwd.multiEmailUsersTip": "ที่อยู่อีเมลถูกผูกไว้กับหลายบัญชี เลือกบัญชีที่คุณต้องการรีเซ็ตรหัสผ่าน",
        "loginRegistTip": "ผู้ใช้ใหม่สามารถลงทะเบียนโดยการเชิญเท่านั้น",
        "activeAccount": "เปิดใช้งาน",
        "uniportalTip": "ผู้ใช้เว็บไซต์อย่างเป็นทางการของ Huawei, พาร์ทเนอร์ทางธุรกิจของ Huawei, พนักงาน Huawei และนักพัฒนา ICT",
        "activeAccountMsg": "เรียนผู้ใช้ นี่เป็นการเข้าสู่ระบบ Huawei Cloud ครั้งแรกของคุณ โปรดอ่านและยอมรับข้อตกลงลูกค้าและคำชี้แจงในการเก็บรวบรวมข้อมูลส่วนบุคคลของ Huawei Cloud ก่อนที่คุณจะดำเนินการต่อไป",
        "accountName": " ชื่อบัญชี",
        "userNameTip": "ชื่อผู้ใช้:",
        "searchBoxPlaceHolder": "โปรดป้อนคำหลัก",
        "submitBtnTxt": "ตกลง",
        "cancelBtnTxt": "ยกเลิก",
        "btnTxtOK": "ตกลง",
        "btnTxtCancel": "ยกเลิก",
        "btnTxtYes": "ใช่",
        "btnTxtNo": "ไม่",
        "logout": "ทางออก",
        "connect": "และ",
        "emptyStr": "--",
        "blankTxt": "ช่องนี้ไม่สามารถเว้นว่างได้",
        "emptyTxt": "ช่องนี้ไม่สามารถเว้นว่างหรือมีช่องว่างได้",
        "nameBlankTxt": "ช่องนี้ไม่สามารถเว้นว่างได้",
        "passwordEqual": "รหัสผ่านไม่ตรงกัน",
        "validEmail": "โปรดป้อนอีเมล์ที่ถูกต้อง",
        "validPhone": "โปรดป้อนหมายเลขโทรศัพท์ที่ถูกต้อง",
        "maxLenTxt": "ความยาวสูงสุด {0} อักขระ",
        "minLenTxt": "ความยาวขั้นต่ำ {0} อักขระ",
        "minMaxLenTxt": "ต้องมีอักขระ {0}–{1} อักขระ",
        "phoneMaxLenTxt": "ความยาวสูงสุด {0} หลัก",
        "msgCodeErrorInfo": "อนุญาตให้ใช้เฉพาะตัวเลขเท่านั้น",
        "nameContainsChar": "อนุญาตเฉพาะตัวอักษร ตัวเลข ยัติภังค์ (-) และขีดล่าง (_) ชื่อต้องขึ้นต้นด้วยตัวอักษรหรือยัติภังค์",
        "commonContainsChar": "อนุญาตให้ใช้เฉพาะตัวอักษรและตัวเลขเท่านั้น",
        "pwdNotUsernameOrInvert": "ไม่สามารถเป็นชื่อผู้ใช้หรือชื่อผู้ใช้ที่สะกดย้อนหลังได้",
        "pwdNotContsMobileOrEmail": "รหัสผ่านต้องไม่มีหมายเลขโทรศัพท์หรือที่อยู่อีเมล",
        "pwdNotContsMobile": "รหัสผ่านไม่สามารถมีหมายเลขโทรศัพท์",
        "pwdcantContsMobileOrEmail": "รหัสผ่านต้องไม่ประกอบด้วยหมายเลขโทรศัพท์หรือที่อยู่อีเมล",
        "pwdWeak": "รหัสผ่านที่คุณป้อนอาจมีความเสี่ยงต่อการรั่วไหล โปรดเปลี่ยนเป็นรหัสผ่านอื่น",
        "usernameNotPwdOrInvert": "ชื่อผู้ใช้ไม่สามารถเป็นรหัสผ่านหรือรหัสผ่านที่สะกดย้อนกลับ",
        "passwordChars": "ต้องมีอักขระประเภทต่อไปนี้อย่างน้อย {0} ประเภท: ตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก ตัวเลข ช่องว่าง และอักขระพิเศษ (~`!?,.:;-_'\"(){}[]/<>@# $%^&*+|=).",
        "mobilePasswordChars1": "รหัสผ่านต้องมีอย่างน้อยสองรายการต่อไปนี้:",
        "mobilePasswordChars2": "ตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก ตัวเลข และอักขระพิเศษ",
        "validEmailOrPhone": "โปรดป้อนที่อยู่อีเมลหรือหมายเลขโทรศัพท์ที่ถูกต้อง",
        "validAccountName": "โปรดป้อนชื่อบัญชีที่ถูกต้อง",
        "validPwd": "โปรดป้อนรหัสผ่านที่ถูกต้อง",
        "validAgency": "โปรดป้อนชื่อตัวแทนที่ถูกต้อง",
        "validCheckCode": "ความยาวสูงสุด 4 อักขระ",
        "tooMuchErrorCode": "คุณขอรหัสยืนยันเกินจำนวนสูงสุดที่อนุญาต โปรดลองอีกครั้งในภายหลัง",
        "pwdCannotEqualName": "ไม่สามารถเป็นชื่อบัญชีหรือชื่อบัญชีที่สะกดย้อนกลับ",
        "passwordPolicy.errorMsgOfRptChar": "รหัสผ่านสามารถมีอักขระที่เหมือนกันติดต่อกันได้สูงสุด {0} อักขระ",
        "inValidCcompanyName": "ต้องไม่มีเฉพาะอักขระพิเศษ ตัวเลข ช่องว่าง หรืออักขระแท็บ",
        "companyNameLength": "ความยาวสูงสุด {0} อักขระ",
        "accountTipInfo": "ข้อมูลบัญชีของคุณ:",
        "yes": "ใช่",
        "no": "ไม่",
        "iamUserTip": "คุณสามารถเข้าสู่ระบบในฐานะผู้ใช้ IAM หากบัญชีของคุณถูกสร้างขึ้นโดยบัญชี Huawei Cloud อื่น",
        "registerFailed": "การลงทะเบียนล้มเหลว",
        "recommended": "การแนะนำสำหรับผู้เริ่มต้น",
        "strengthLow": "อ่อนแอ",
        "strengthMid": "ปานกลาง",
        "strengthHigh": "แข็งแกร่ง",
        "accountNameBlank": "โปรดป้อนชื่อบัญชี",
        "userNameBlank": "โปรดป้อนชื่อผู้ใช้ IAM หรือที่อยู่อีเมล",
        "pwdBlank": "โปรดป้อนรหัสผ่าน",
        "checkCodeBlank": "โปรดป้อนรหัสยืนยัน",
        "backToHomepage": "กลับไปหน้าแรก",
        "mobileHome": "หน้าแรก",
        "backTo": "กลับ",
        "homepage": "หน้าแรก",
        "isHwsUser": "บัญชีของคุณได้ลงทะเบียนบนเว็บไซต์ของ Huawei Cloud China และสามารถใช้ได้ที่นั่นเท่านั้น",
        "isHongKongUser": "บัญชีของคุณได้ลงทะเบียนบนเว็บไซต์ Huawei Cloud International และสามารถใช้ได้ที่นั่นเท่านั้น",
        "isRuUser": "บัญชีของคุณได้ลงทะเบียนบนเว็บไซต์ Huawei Cloud International และสามารถใช้ได้ที่นั่นเท่านั้น",
        "isHwsUser1": "บัญชีของคุณได้ลงทะเบียนบน",
        "isHongKongUser1": "บัญชีของคุณได้ลงทะเบียนบน",
        "isRuUser1": "บัญชีของคุณได้ลงทะเบียนบน",
        "goLogin.hws": "เว็บไซต์ Huawei Cloud ประเทศจีน",
        "goLogin.hk": "เว็บไซต์นานาชาติของ Huawei Cloud",
        "goLogin.ru": "เว็บไซต์นานาชาติของ Huawei Cloud",
        "language": "ภาษาอังกฤษ",
        "lanuage.hk": "International",
        "lanuage.ch": "中国站",
        "language.zh-cn": "简体中文",
        "language.en-us": "English",
        "titles.login": "Huawei Cloud - เข้าสู่ระบบ",
        "titles.resetPwd": "Huawei Cloud - รีเซ็ตรหัสผ่าน",
        "titles.fpwd": "Huawei Cloud - ลืมรหัสผ่าน",
        "titles.register": "Huawei Cloud - ลงทะเบียน",
        "titles.agencyRegister": "Huawei Cloud - ลงทะเบียนตัวแทน",
        "titles.reactivate": "Huawei Cloud - เปิดใช้งานอีกครั้ง",
        "titles.registerSuccess": "Huawei Cloud - การลงทะเบียนสำเร็จ",
        "titles.fphone": "Huawei Cloud - เปลี่ยนหมายเลขโทรศัพท์",
        "titles.loginVerification": "Huawei Cloud - การยืนยันการเข้าสู่ระบบ",
        "titles.bindAccount": "Huawei Cloud - เข้าสู่ระบบครั้งแรก",
        "titles.bindAccountSuccess": "Huawei Cloud - การลงทะเบียนสำเร็จ (ลงทะเบียนและผูกมัด)",
        "registerFree": "การลงทะเบียนบัญชี Huawei Cloud",
        "freeRegister": "ลงทะเบียนฟรี",
        "createDomain": "สร้างบัญชี",
        "createDomainBtn": "สร้างและผูก",
        "createSubUser": "สร้างบัญชีผู้ใช้ย่อย",
        "createFailed": "การสร้างบัญชีล้มเหลว",
        "bindDomain": "ผูกบัญชี",
        "createDomainLink": "สร้างบัญชี",
        "bindDomainLink": "ผูกบัญชี",
        "bindFailed": "การผูกบัญชีล้มเหลว",
        "bindRepeat": "บัญชีของคุณถูกผูกไว้กับพาร์ทเนอร์รายอื่นแล้ว คุณไม่สามารถผูกบัญชีกับพาร์ทเนอร์มากกว่าหนึ่งราย",
        "createDomain.remindCompleteInfo": "โปรดกรอกข้อมูลต่อไปนี้เพื่อสร้างและผูกบัญชี Huawei Cloud มีบัญชีอยู่แล้วหรือ",
        "bindDomain.remindCompleteInfo": "โปรดป้อนข้อมูลบัญชี Huawei Cloud ของคุณเพื่อผูกกับบัญชีนี้ ยังไม่มีบัญชีหรือ",
        "createSubUserInfo": "โปรดกรอกข้อมูลต่อไปนี้เพื่อสร้างและผูกบัญชีผู้ใช้ย่อยของ Huawei Cloud",
        "enterpriseUser": "เข้าสู่ระบบผู้ใช้ IAM",
        "enterpriseUserLogin": "เข้าสู่ระบบผู้ใช้ IAM",
        "personageUser": "เข้าสู่ระบบบัญชี",
        "enterpriseUser4Intl": "เข้าสู่ระบบผู้ใช้ IAM (International)",
        "personageUser4Intl": "เข้าสู่ระบบบัญชี (International)",
        "accountPlaceHolder": "ชื่อบัญชี",
        "domainPlaceHolder": "รหัส/ชื่อตัวแทน",
        "roleNamePlaceHolder": "ชื่อตัวแทน",
        "failedToswitchRole": "การเปลี่ยนตัวแทนล้มเหลว",
        "switchSubmit": "เปลี่ยนบทบาท",
        "agencyDesc": "คุณสามารถใช้ ID ผู้ใช้และรหัสผ่านเพื่อจัดการทรัพยากรของหลายบัญชี หลังจากที่ผู้ดูแลระบบ Huawei Cloud กำหนดบทบาทให้คุณแล้ว",
        "userNamePlaceHolder": "ชื่อผู้ใช้ IAM ที่อยู่อีเมล หรือหมายเลขโทรศัพท์",
        "HongKongUserNamePlaceHolder": "ชื่อผู้ใช้ IAM หรือที่อยู่อีเมล",
        "accountNamePlaceHolder": "ชื่อบัญชี ที่อยู่อีเมล หรือหมายเลขโทรศัพท์",
        "HongKongAccountNamePlaceHolder": "ชื่อบัญชีหรือที่อยู่อีเมล",
        "accountTip": "บัญชี",
        "passwdPlaceHolder": "รหัสผ่าน",
        "iamPasswdPlaceHolder": "รหัสผ่านผู้ใช้ IAM",
        "verifyCodePlaceHolder": "รหัสแคปต์ชา",
        "GraphicsVerifyCodeLabel": "รหัสแคปต์ชา:",
        "GraphicsVerifyCode": "การตรวจสอบความปลอดภัย",
        "InputGrapVerifyCodeInfo": "เพื่อรักษาความปลอดภัยของบัญชี โปรดป้อนอักขระที่แสดงในภาพต่อไปนี้",
        "GrapVerifyCodeFailed": "รหัสแคปต์ชาไม่ถูกต้องหรือหมดอายุแล้ว \r\nโปรดป้อนรหัสที่ถูกต้อง",
        "getVerifyCode": "รีเฟรชรูปภาพ",
        "loginSubmit": "เข้าสู่ระบบ",
        "logining": "กำลังเข้าสู่ระบบ...",
        "rememberName": " จดจำฉันไว้",
        "rememberLogin": " จดจำฉันไว้",
        "forgetPwd": "ลืมรหัสผ่าน",
        "emaiNamePwd": "ที่อยู่อีเมลไม่ถูกต้อง",
        "phoneNamePwd": "มายเลขโทรศัพท์ไม่ถูกต้อง",
        "domainNamePwd": "ชื่อบัญชีไม่ถูกต้อง",
        "wrongNamePwd": "รหัสผ่านไม่ถูกต้อง",
        "learnMore": "เรียนรู้เพิ่มเติม",
        "iamAccountTip": "บัญชีที่ใช้สร้างผู้ใช้ IAM ใน IAM",
        "iamUsernameTip": "ผู้ใช้ IAM ที่สร้างโดยใช้บัญชีใน IAM",
        "iamAccountTipHelp": "/en-us/productdesc-iam/iam_01_0023.html?utm_campaign=ua&utm_content=iam&utm_term=login#section0",
        "iamUsernameTipHelp": "/en-us/productdesc-iam/iam_01_0023.html?utm_campaign=ua&utm_content=iam&utm_term=login#section1",
        "userNameMobliePH": "มายเลขโทรศัพท์",
        "mobileNumberLogin": "มายเลขโทรศัพท์",
        "noMobileLogin": "ชื่อบัญชีหรืออีเมล",
        "phoneBlank": "โปรดป้อนหมายเลขโทรศัพท์",
        "wrongIPBlacklist": "อุปกรณ์ที่คุณใช้เพื่อเข้าสู่ระบบไม่ปลอดภัย โปรดใช้อุปกรณ์อื่น",
        "wrongIPFrequencyLimiting": "ถึงจำนวนครั้งสูงสุดในการพยายามเข้าสู่ระบบที่ไม่สำเร็จที่อนุญาตจากที่อยู่ IP เดียวกันแล้ว โปรดลองอีกครั้งในภายหลัง",
        "wrongEquipmentIDFrequencyLimiting": "ถึงจำนวนครั้งสูงสุดในการพยายามเข้าสู่ระบบที่ไม่สำเร็จที่อนุญาตจากอุปกรณ์เดียวกัน โปรดลองอีกครั้งในภายหลังหรือใช้อุปกรณ์อื่น",
        "MachineOperation": "อุปกรณ์ที่คุณใช้เพื่อเข้าสู่ระบบไม่ปลอดภัย โปรดใช้อุปกรณ์อื่น",
        "emaiNamePwdChances": "ที่อยู่อีเมลไม่ถูกต้อง คุณจะต้องเข้าสู่ระบบอีกครั้งหากพยายามอีก {0} ครั้งไม่สำเร็จ",
        "phoneNamePwdChances": "หมายเลขโทรศัพท์ไม่ถูกต้อง คุณจะต้องเข้าสู่ระบบอีกครั้งหากพยายามอีก {0} ครั้งไม่สำเร็จ",
        "domainNamePwdChances": "ชื่อบัญชีไม่ถูกต้อง คุณจะต้องลงชื่อเข้าใช้อีกครั้งหากพยายามอีก {0} ครั้งไม่สำเร็จ",
        "wrongNamePwdChances": "รหัสผ่านไม่ถูกต้อง คุณจะต้องเข้าสู่ระบบอีกครั้งหากพยายามอีก {0} ครั้งไม่สำเร็จ",
        "wrongNamePwdFourChances": "ข้อมูลการรับรองความถูกต้องไม่ถูกต้อง การพยายามไม่สำเร็จอีก 4 ครั้งจะปิดการเข้าสู่ระบบเป็นเวลา 15 นาที",
        "wrongNamePwdThreeChances": "ข้อมูลการรับรองความถูกต้องไม่ถูกต้อง การพยายามไม่สำเร็จอีก 3 ครั้งจะปิดการเข้าสู่ระบบเป็นเวลา 15 นาที",
        "wrongNamePwdTwoChances": "ข้อมูลการรับรองความถูกต้องไม่ถูกต้อง หากพยายามอีก 2 ครั้งที่ไม่สำเร็จ ระบบจะปิดการเข้าสู่ระบบเป็นเวลา 15 นาที",
        "wrongNamePwdoneChances": "ข้อมูลการรับรองความถูกต้องไม่ถูกต้อง การพยายามไม่สำเร็จอีก 1 ครั้งจะปิดการเข้าสู่ระบบเป็นเวลา 15 นาที",
        "userAccountsStopped": "บัญชีของคุณถูกปิดใช้งาน โปรดติดต่อผู้ดูแลระบบ",
        "domainAccountsStopped": "บัญชีของคุณถูกปิดการใช้งาน",
        "userAccountsLocked": "คุณได้ป้อนชื่อผู้ใช้หรือรหัสผ่านที่ไม่ถูกต้องถึง 5 ครั้ง ที่อยู่ IP ที่คุณใช้สำหรับเข้าสู่ระบบจะถูกล็อคเป็นเวลา 15 นาที",
        "clientIpInvalid": "คุณไม่ได้รับอนุญาตให้เข้าสู่ระบบจากอุปกรณ์นี้เนื่องจากกฎการควบคุมการเข้าถึงที่กำหนดโดยผู้ดูแลระบบ <a href=\"{0}\" target=\"_blank\" rel=\"noopener noreferrer\">เรียนรู้เพิ่มเติม</a>",
        "clientIpInvalid.resetPwd": "คุณไม่ได้รับอนุญาตให้รีเซ็ตรหัสผ่านจากอุปกรณ์นี้เนื่องจากกฎการควบคุมการเข้าถึงที่กำหนดโดยผู้ดูแลระบบ",
        "clientIpInvalid.helpUrl": "/en-us/usermanual-iam/iam_07_0003.html",
        "notAllowFpwd": "คุณไม่ได้รับอนุญาตให้รีเซ็ตรหัสผ่านโดยใช้อุปกรณ์นี้",
        "warning": "คำเตือน",
        "systemException": "ระบบไม่ว่าง โปรดรีเฟรชเพจแล้วลองอีกครั้ง",
        "freqLocked": "คุณลองหลายครั้งเกินไป โปรดลองใหม่ในภายหลัง",
        "wrongVerifyCode": "รหัสยืนยันไม่ถูกต้องหรือหมดอายุแล้ว",
        "invalidInput": "ค่าพารามิเตอร์ไม่ถูกต้อง",
        "serviceUrlInvalid": "การเข้าสู่ระบบล้มเหลว <a href=\"/\">ลองอีกครั้ง</a>",
        "maxSessionLimit": "ถึงจำนวนสูงสุดของเซสชันผู้ใช้ออนไลน์แล้ว",
        "multiUserInvalid": "คุณเข้าสู่ระบบจากอุปกรณ์นี้แล้ว โปรดรีเฟรชเพจหรือออกจากระบบหากคุณต้องการใช้บัญชีอื่นเพื่อเข้าสู่ระบบอีกครั้ง",
        "pageTimeout": "หมดเวลาดำเนินการ รีเฟรชเพจแล้วลองอีกครั้ง",
        "accountClosed": "กำลังปิดบัญชี",
        "invalidInputFourChances": "พารามิเตอร์ไม่ถูกต้อง การพยายามไม่สำเร็จอีก 4 ครั้งจะปิดการเข้าสู่ระบบเป็นเวลา 15 นาที",
        "invalidInputThreeChances": "พารามิเตอร์ไม่ถูกต้อง การพยายามไม่สำเร็จอีก 3 ครั้งจะปิดการเข้าสู่ระบบเป็นเวลา 15 นาที",
        "invalidInputTwoChances": "พารามิเตอร์ไม่ถูกต้อง การพยายามไม่สำเร็จอีก 2 ครั้งจะปิดการเข้าสู่ระบบเป็นเวลา 15 นาที",
        "invalidInputoneChances": "พารามิเตอร์ไม่ถูกต้อง การพยายามไม่สำเร็จอีก 1 ครั้งจะปิดการเข้าสู่ระบบเป็นเวลา 15 นาที",
        "loginReactivateFail": "การส่งอีเมลเปิดใช้งานล้มเหลว โปรดลองอีกครั้ง",
        "pwdSame": "รหัสผ่านใหม่จะต้องแตกต่างจากรหัสผ่านเดิม",
        "initialPwdSame": "รหัสผ่านใหม่จะต้องแตกต่างจากรหัสผ่านเริ่มต้น",
        "historyPwdSame": "รหัสผ่านใหม่จะต้องแตกต่างจากรหัสผ่านในอดีต",
        "copyrightNotice1": "© {0} ลิขสิทธิ์โดย Huawei Cloud สงวนลิขสิทธิ์",
        "copyrightNotice1_hk": "© {0}, Huawei Cloud Computing Technologies Co., Ltd. และ/หรือบริษัทในเครือ สงวนลิขสิทธิ์",
        "copyrightNotice2": "สงวนลิขสิทธิ์",
        "copyrightNotice3": "หมายเลขลงทะเบียน Jiangsu ICP: 17040376-32",
        "copyrightNotice4": "Jiangsu B2-20130048",
        "copyrightNotice5": "หมายเลขลงทะเบียนเว็บไซต์ Jiangsu Public Security: 32011402010636",
        "legalNotice": "ประกาศทางกฎหมาย",
        "legalStatement": "ประกาศทางกฎหมาย",
        "reportAbuse": "รายงานการล่วงละเมิด",
        "sa_nisr": "นโยบายการใช้งานที่ยอมรับได้",
        "sa_nisr_intl": "นโยบายการใช้งานที่ยอมรับได้",
        "siteTerms": "ข้อกำหนดเว็บไซต์",
        "privacyProtect": "คำชี้แจงในการเก็บรวบรวมข้อมูลส่วนบุคคล",
        "privacyStrategyStatement": "คำชี้แจงในการเก็บรวบรวมข้อมูลส่วนบุคคล",
        "sa_cua": "ข้อตกลงสำหรับลูกค้า Huawei Cloud",
        "sa_cua_intl": "ข้อตกลงสำหรับลูกค้า Huawei Cloud",
        "enterpriseSwitchTip": "โหมดการเข้าสู่ระบบนี้ใช้สำหรับการเข้าสู่ระบบด้วยชื่อผู้ใช้ที่กำหนดโดยผู้ดูแลระบบขององค์กร",
        "personalSwitchTip": "โหมดการเข้าสู่ระบบนี้ใช้สำหรับการเข้าสู่ระบบด้วยชื่อบัญชีที่สร้างขึ้นเมื่อการลงทะเบียนบัญชี",
        "usingOtherWaysLogin": "ใช้บัญชีอื่น",
        "otherWaysLogin": "เข้าสู่ระบบโดยใช้บัญชีอื่น",
        "HWSdeveloper": "Huawei Developer Alliance",
        "HWICTdeveloper": "Huawei ICT Developer",
        "hwportal": "เว็บไซต์อย่างเป็นทางการของ Huawei",
        "WeLink": "บัญชี WeLink",
        "readAgree": "ข้าพเจ้าได้อ่านและยอมรับ",
        "hwCloudAgreement": `${BRAND} Customer Agreement`,
        "secretprotect": "คำชี้แจงในการเก็บรวบรวมข้อมูลส่วนบุคคล",
        "companyUserRegistration": "ลงทะเบียนผู้ใช้องค์กร",
        "personalUserRegistration": "ลงทะเบียนผู้ใช้",
        "companyAccountName": "ชื่อผู้ใช้:",
        "userName": "ชื่อผู้ใช้:",
        "registerMail": "ที่อยู่อีเมล:",
        "password": "รหัสผ่าน:",
        "registerMailStep3": "อีเมล:",
        "passwordPlaceHolder": "โปรดป้อนรหัสผ่าน",
        "confirmPassword": "ยืนยันรหัสผ่าน:",
        "confirmPasswordPlaceHolder": "โปรดป้อนรหัสผ่านอีกครั้ง",
        "companyName": "องค์กร:",
        "contact": "ผู้ติดต่อ:",
        "phoneNum": "มายเลขโทรศัพท์:",
        "phonePlaceHolder": "โปรดป้อนหมายเลขโทรศัพท์ของคุณ",
        "msgCode": "รหัสยืนยัน:",
        "msgCodeTxt": "ส่งรหัส",
        "msgPHTxt": "รหัสยืนยัน",
        "msgCodeTxtWait": "ส่งรหัสอีกครั้ง ({0}วินาที)",
        "msgCodeWrong": "รหัสยืนยันไม่ถูกต้อง",
        "region": "ภาค:",
        "register.submit": "ลงทะเบียน",
        "register.finish": "เสร็จสิ้น",
        "innerKeyWord": "ชื่อไม่สามารถขึ้นต้นด้วยคีย์เวิร์ดของระบบ",
        "accountNamePH": "โปรดป้อนชื่อผู้ใช้ของคุณ",
        "emailPH": "โปรดป้อนที่อยู่อีเมลของคุณ",
        "mobileCompanyName": "(ไม่บังคับ) โปรดป้อนชื่อองค์กรของคุณ",
        "companyNamePH": "โปรดป้อนชื่อองค์กรของคุณ",
        "registerSuccess": "การลงทะเบียนสำเร็จแล้ว",
        "pleaseCompleteInfo": "เพื่อรักษาความปลอดภัยของบัญชี โปรดกรอกข้อมูลเกี่ยวกับองค์กรของคุณให้ครบถ้วน",
        "complete": "กรอก",
        "companyInfo": "โปรไฟล์องค์กร",
        "rejectAndBack": "กลับไปที่",
        "homePage": "หน้าแรก",
        "period": ".",
        "goTo": " ไปที่",
        "myCredential": "ข้อมูลเอกลักษณ์ของฉัน",
        "completeUserInfo": "เพื่อกรอกข้อมูลส่วนตัวให้ครบถ้วน",
        "fpwd.findPasswd": "รีเซ็ตรหัสผ่าน",
        "fpwd.enterpriseName": "ชื่อบัญชี:",
        "fpwd.accountName": "ที่อยู่อีเมลหรือหมายเลขโทรศัพท์:",
        "fpwd.SMSVerifyCode": "โปรดป้อนรหัสยืนยัน",
        "fpwd.emailVerifyCode": "โปรดป้อนรหัสยืนยัน",
        "fpwd.getCode": "ส่งรหัสยืนยัน",
        "fpwd.confirmAccount": "ยืนยันตัวตน",
        "fpwd.resetPwd": "รีเซ็ตรหัสผ่าน",
        "fpwd.resetSuccess": "เสร็จสิ้น",
        "fpwd.findSuccess": "รีเซ็ตรหัสผ่านสำเร็จแล้ว",
        "fpwd.newPasswd": "รหัสผ่านใหม่:",
        "fpwd.confirmPasswd": "ยืนยันรหัสผ่าน:",
        "fpwd.enterpriseNamePH": "โปรดป้อนชื่อบัญชี",
        "fpwd.accountNamePH": "โปรดป้อนที่อยู่อีเมลหรือหมายเลขโทรศัพท์",
        "fpwd.verifyCodePH": "รหัสยืนยัน",
        "fpwd.newPasswdPH": "โปรดป้อนรหัสผ่านใหม่",
        "fpwd.newPasswdPHApp": "รหัสผ่านใหม่",
        "fpwd.nextStepBtn": "ต่อไป",
        "fpwd.backTo": "กลับ",
        "fpwd.titleDetail": "โปรดป้อนข้อมูลบัญชีของคุณ",
        "fpwd.titleIAMDetail": "โปรดป้อนข้อมูลผู้ใช้ IAM ของคุณ",
        "fpwd.multiUsersTip": "หมายเลขโทรศัพท์ถูกผูกไว้กับหลาย ๆ บัญชีแล้ว โปรดเลือกบัญชีที่คุณต้องการรีเซ็ตรหัสผ่าน",
        "fpwd.accountConfirm": "การยืนยันบัญชี",
        "fpwd.personalAccount": "บัญชี",
        "fpwd.IAMAccount": "ผู้ใช้ IAM",
        "fpwd.typePersonalTip": "บัญชีที่สร้างขึ้นเมื่อคุณลงทะเบียนกับ Huawei Cloud โดยใช้หมายเลขโทรศัพท์",
        "fpwd.typeIAMTip": "ผู้ใช้ที่สร้างโดยใช้บัญชีใน IAM",
        "fpwd.IAMAccountNamePH": "ชื่อผู้ใช้ IAM ที่อยู่อีเมล หรือหมายเลขโทรศัพท์",
        "fpwd.identityVerification": "การยืนยันตัวตน",
        "fpwd.identityVerificationDec": "เลือกวิธีการยืนยันตัวตน",
        "fpwd.passwordReset": "รีเซ็ตรหัสผ่าน",
        "fpwd.passwordResetDesc": "ตั้งรหัสผ่านใหม่",
        "fpwd.step1.fpwdByemail": "การยืนยันด้วยบัญชี/อีเมล",
        "fpwd.step2.verificationCodePH": "รหัสยืนยัน",
        "fpwd.step2.unbindDesc": "ไม่สามารถยืนยันตัวตนของคุณได้เนื่องจากบัญชีที่คุณใช้ไม่ได้ผูกกับที่อยู่อีเมลหรือหมายเลขโทรศัพท์",
        "fpwd.step2.unbindIAMDesc": "ไม่มีอีเมลหรือหมายเลขโทรศัพท์ที่เชื่อมโยงกับผู้ใช้ IAM รายนี้ ติดต่อผู้ดูแลบัญชีเพื่อรีเซ็ตรหัสผ่าน",
        "fpwd.step2.exceptionService": "หากหมายเลขโทรศัพท์หรือที่อยู่อีเมลของคุณไม่พร้อมใช้งาน โปรดขอให้ผู้ดูแลระบบรีเซ็ตรหัสผ่านของคุณ",
        "fpwd.step2.sendEmailCode": "ที่อยู่อีเมล ({0})",
        "fpwd.step2.sendMobileCode": "หมายเลขโทรศัพท์ ({0})",
        "fpwd.step2.unabledMethod": "ติดต่อฝ่ายบริการลูกค้า",
        "fpwd.step2.helpMsg": "บริการลูกค้า",
        "fpwd.step2.helpTel1": "แผ่นดินใหญ่จีน: +86 4000-955-988",
        "fpwd.step2.helpTel2": "เขตบริหารพิเศษฮ่องกงแห่งประเทศจีน: +852 800-931-122",
        "fpwd.retrieveTxt": "ส่งรหัสอีกครั้ง ({0}วินาที)",
        "fpwd.step3.showPwdTip": "แสดง",
        "fpwd.step3.hidePwdTip": "ซ่อน",
        "fpwd.goToLogin": "เข้าสู่ระบบ",
        "fpwd.successTxt": "รีเซ็ตรหัสผ่านสำเร็จแล้ว",
        "fpwd.loginCountdownTxt": "คุณจะถูกนำไปหน้าเข้าสู่ระบบโดยอัตโนมัติใน {0}วินาที",
        "resetPwd.apiKeyTitle": "เปลี่ยนรหัสผ่าน API",
        "resetPwd.apiKeyDetail": "เพื่อรักษาความปลอดภัยของบัญชี โปรดเปลี่ยนรหัสผ่าน API",
        "resetPwd.apkKey": "รหัสผ่าน API เดิม:",
        "domainuserAccountsLocked": "บัญชีของคุณกำลังรอการเปิดใช้งาน คลิกลิงก์ในอีเมลการลงทะเบียนเพื่อเปิดใช้งานบัญชีของคุณ",
        "fpwd.sendCodeFailed": "ไม่สามารถส่งรหัสยืนยันได้เนื่องจากระบบไม่ว่าง",
        "fpwd.getCodeFail": "จำนวนการรับรหัสยืนยันถึงขีดจำกัด 5 ครั้งแล้ว โปรดลองอีกครั้งในวันพรุ่งนี้",
        "wrong_sendCodeFailed": "การส่งรหัสยืนยันล้มเหลว คลิกส่งรหัสยืนยันเพื่อรับรหัสใหม่",
        "fpwd.invalidVerifyCode": "รหัสยืนยันไม่ถูกต้อง โปรดลองอีกครั้ง",
        "fpwd.ipLocked": "ที่อยู่ IP ถูกล็อค",
        "fpwd.MultipleIAMUserNameByMobile": "หมายเลขโทรศัพท์ถูกผูกไว้กับผู้ใช้ IAM หลายคนแล้ว โปรดรีเซ็ตรหัสผ่านโดยใช้อีเมลของคุณ",
        "fpwd.MultipleAccountNameByMobile": "หมายเลขโทรศัพท์ถูกผูกไว้กับหลายบัญชีแล้ว โปรดป้อนชื่อบัญชีเพื่อดำเนินการต่อ",
        "fpwd.MultipleAccountNameByMobileError": "หมายเลขโทรศัพท์ถูกผูกไว้กับหลายบัญชีแล้ว โปรดรีเซ็ตรหัสผ่านโดยใช้หมายเลขโทรศัพท์นี้บนคอมพิวเตอร์หรือใช้อีเมลของคุณ",
        "fpwd.MultipleAccountsByMobileReminder": "ต้องระบุชื่อบัญชีหากหมายเลขโทรศัพท์ผูกกับหลายบัญชี",
        "fpwd.EnterCorrectEnterpriseAccount": "โปรดป้อนชื่อบัญชี Huawei Cloud ที่ถูกต้อง หากคุณอัปเกรดบัญชี Huawei Cloud ของคุณเป็น HUAWEI ID ให้คลิกลืมรหัสผ่านในหน้าเข้าสู่ระบบ HUAWEI ID",
        "fpwd.EnterCorrectMobile": "โปรดป้อนหมายเลขโทรศัพท์ที่ลงทะเบียนกับ Huawei Cloud หากคุณอัปเกรดบัญชี Huawei Cloud ของคุณเป็น HUAWEI ID ให้คลิกลืมรหัสผ่านในหน้าเข้าสู่ระบบ HUAWEI ID",
        "fpwd.EnterCorrectEnterpriseAccountAndMobile": "โปรดป้อนชื่อบัญชีหรือหมายเลขโทรศัพท์ที่ลงทะเบียนกับ Huawei Cloud",
        "fpwd.EnterCorrectEmail": "โปรดป้อนที่อยู่อีเมลที่ลงทะเบียนกับ Huawei Cloud",
        "fpwd.EnterCorrectEnterpriseAccountAndEmail": "โปรดป้อนชื่อบัญชีหรือที่อยู่อีเมลที่ถูกต้อง",
        "fpwd.EnterCorrectEnterpriseVerificationCode": "โปรดป้อนรหัสแคปต์ชาที่ถูกต้อง",
        "operationTooFrequent": "คุณลองหลายครั้งเกินไป โปรดลองใหม่ในภายหลัง",
        "fpwd.contactService": "หากคุณไม่มีสิทธิ์เข้าถึงโทรศัพท์และอีเมล โปรดติดต่อฝ่ายบริการลูกค้าที่ {0} เพื่อขอความช่วยเหลือ",
        "fpwd.contactHKService": "หากคุณไม่มีสิทธิ์เข้าถึงอีเมล โปรดติดต่อฝ่ายบริการลูกค้าที่ {0} เพื่อขอความช่วยเหลือ",
        "fpwd.ErrorRegionAccount": "โปรดป้อนบัญชี Huawei Cloud ที่ถูกต้อง",
        "bindPhone": "มายเลขโทรศัพท์:",
        "bindPhoneNum": "มายเลขโทรศัพท์:",
        "login": "เข้าสู่ระบบ",
        "loginNow": "เข้าสู่ระบบ",
        "safetyDegree": "ความรัดกุมของรหัสผ่าน:",
        "handsRegisterInfo": "การใช้ Huawei PDA Cloud Service",
        "hansRegistration": "สมัครเลย",
        "filloutRegisterInfo": "ตั้งค่าข้อมูลการลงทะเบียน",
        "checkAccountInfo": "กรอกข้อมูลบัญชีให้ครบถ้วน",
        "registerSucceed": "เสร็จสิ้น",
        "congratulationsSucceed": "การลงทะเบียนสำเร็จ",
        "successAccoutInfo": "ข้อมูลบัญชีของคุณ:",
        "descriptionInfo": "คุณสามารถเข้าสู่ระบบโดยใช้ชื่อบัญชี หมายเลขโทรศัพท์ หรือที่อยู่อีเมล",
        "linkFailed": "ลิงก์หมดอายุแล้ว",
        "linkFailedDetail": "บัญชีของคุณได้เปิดใช้งานแล้ว หรือลิงก์เปิดใช้งานได้หมดอายุ",
        "linkFailedLogin": "เข้าสู่ระบบ",
        "serverTimeout": "เซิร์ฟเวอร์หมดเวลา โปรดลองอีกครั้งในภายหลัง",
        "mainMsg": "อีเมลเปิดใช้งานถูกส่งไปยัง:",
        "secondMsg": "คลิกลิงก์ในอีเมลและดำเนินการเปิดใช้งานให้เสร็จสิ้นภายใน 24 ชั่วโมง",
        "checkEmail": "เปิดอีเมล",
        "didNotGetEmail": "ไม่ได้รับอีเมลหรือ",
        "checkSpamMail": "1.ตรวจสอบโฟลเดอร์อีเมลขยะของคุณ",
        "stillDidNotGetEmail": "2.หากคุณไม่ได้รับอีเมล",
        "resendEmail": "ส่งอีเมลอีกครั้ง",
        "alwaysDidNotGetEmail": "3.หากคุณยังไม่ได้รับอีเมล",
        "changeMailbox": "โปรดป้อนที่อยู่อีเมลอื่น",
        "replaceEmailTip": "คุณสามารถเปลี่ยนที่อยู่อีเมลของคุณได้เพียงครั้งเดียวใน 24 ชั่วโมง โปรดตรวจสอบให้แน่ใจว่าคุณได้ป้อนที่อยู่อีเมลที่ถูกต้อง",
        "sendNewEmail": "ส่ง",
        "alreadySend": "ส่งอีเมลเปิดใช้งานแล้ว",
        "sendFailed": "การส่งอีเมลล้มเหลว",
        "inputEmail": "โปรดป้อนอีเมลล์ของคุณ",
        "email": "อีเมล:",
        "countToHomepage": "คุณจะถูกนำไปยังหน้าเข้าสู่ระบบโดยอัตโนมัติใน {0} วินาที",
        "registerFailed.emailRepeat": "มีบัญชีที่เชื่อมโยงกับที่อยู่อีเมลนี้อยู่แล้ว",
        "registerFailed.nameRepeat": "มีบัญชีที่เชื่อมโยงกับชื่อนี้แล้ว",
        "registerFailed.mobileRepeat": "มีบัญชีที่เชื่อมโยงกับหมายเลขโทรศัพท์นี้อยู่แล้ว",
        "registerFailed.nameCannotBegin": "ชื่อต้องไม่ขึ้นต้นด้วยตัวเลขหรือขีดล่าง (_)",
        "registerFailed.nameCannotContain": "อนุญาตให้ใช้เฉพาะตัวอักษร ตัวเลข ขีดกลาง (-) และขีดล่าง (_) เท่านั้น",
        "registerSuccess.backToHomepage": "1. ",
        "registerSuccess.returnHomepage": "กลับ",
        "usercompanyAccount": "ข้อมูลบัญชีของคุณมีดังนี้:",
        "registerSuccess.backToHomepageLink": "กลับไปที่หน้าแรกของ Huawei Cloud",
        "registerSuccess.backToHomepageLinkP1": "กลับไปที่",
        "registerSuccess.backToHomepageLinkP2": "หน้าแรกของ Huawei Cloud",
        "registerSuccess.second": 2,
        "registerSuccess.goToBss": "ไป",
        "registerSuccess.goToBssFillInfo": " และกรอกข้อมูลการลงทะเบียนให้ครบถ้วน คุณจะได้รับข้อมูลล่าสุดเกี่ยวกับส่วนลดและโปรโมชั่นต่าง ๆ เป็นประจำ",
        "registerSuccess.bssAccountInfo": "ศูนย์ผู้ใช้",
        "registerSuccess.redirecting": "กำลังไปที่...",
        "registerSuccess.redirecting.back": "คุณจะถูกนำไปยังหน้าแรกโดยอัตโนมัติใน {0} วินาที",
        "registerSuccess.autoClose": "คุณจะถูกนำไปยังหน้าแรกโดยอัตโนมัติใน {0} วินาที",
        "registerSuccess.browserPreventClose": "การกำหนดค่าเบราว์เซอร์ของคุณไม่อนุญาตให้ระบบปิดหน้าโดยอัตโนมัติ",
        "registerSuccess.homepage": "หน้าแรก",
        "registerSuccess.userCenter": "ศูนย์ผู้ใช้",
        "registerSuccess.consoleHome": "คอนโซลการจัดการ",
        "registerSuccess.helpCenter": "ความช่วยเหลือ",
        "resetPwd.title": "เข้าสู่ระบบครั้งแรก",
        "resetPwd.titleDetail": "เพื่อรักษาความปลอดภัยของบัญชี โปรดเปลี่ยนรหัสผ่าน",
        "resetPwd.phone": "มายเลขโทรศัพท์:",
        "resetPwd.mailbox": "ที่อยู่อีเมล:",
        "resetPwd.byPhone": "การยืนยันหมายเลขโทรศัพท์",
        "resetPwd.byMailbox": "การยืนยันที่อยู่อีเมล",
        "resetPwd.smsMsgCode": "รหัสยืนยัน:",
        "resetPwd.emailMsgCode": "รหัสยืนยัน:",
        "resetPwd.getSmsMsgCode": "ส่งรหัสยืนยัน",
        "resetPwd.getEmailMsgCode": "ส่งรหัสยืนยัน",
        "resetPwd.retrieveMsgCode": "ส่งรหัสยืนยันอีกครั้ง ({0}วินาที)",
        "resetPwd.resetFailed": "การเปลี่ยนรหัสผ่านล้มเหลว",
        "resetPwd.oldPasswd": "รหัสผ่านเดิม:",
        "resetPwd.newPasswd": "รหัสผ่านใหม่:",
        "resetPwd.confirmNewPasswd": "ยืนยันรหัสผ่าน:",
        "resetPwd.resetPwdFailed": "รหัสผ่านเดิมไม่ถูกต้อง โปรดป้อนรหัสผ่านที่ถูกต้อง",
        "resetPwd.getCodeFail": "จำนวนการรับรหัสยืนยันถึงขีดจำกัด 5 ครั้งแล้ว โปรดลองอีกครั้งในอีก 15 นาที",
        "resetPwd.resetCount": "รหัสผ่านเดิมไม่ถูกต้อง คุณจะต้องเข้าสู่ระบบอีกครั้งหากพยายามอีก {0} ครั้งไม่สำเร็จ",
        "resetPwd.InitPasswd": "รหัสผ่านเริ่มต้น:",
        "resetPwd.InitPasswdError": "รหัสผ่านเริ่มต้นไม่ถูกต้อง ป้อนรหัสผ่านที่ถูกต้อง",
        "resetPwd.InitPasswdCount": "รหัสผ่านเริ่มต้นไม่ถูกต้อง คุณจะต้องเข้าสู่ระบบอีกครั้งหากพยายามอีก {0} ครั้งไม่สำเร็จ",
        "modifyPwdIntervalTimeLessThanMinValidTime": "ช่วงเวลาในการเปลี่ยนรหัสผ่านต้องน้อยกว่าเวลาการใช้รหัสผ่านขั้นต่ำ กรุณาแก้ไขรหัสผ่านหลังจากเวลาขั้นต่ำที่ใช้รหัสผ่าน คลิกยกเลิกเพื่อเข้าสู่ระบบ",
        "pwdModifyTitle": "เปลี่ยนรหัสผ่าน",
        "pwdExpiredTitle": "รหัสผ่านหมดอายุแล้ว",
        "pwdExpiringDesc": "รหัสผ่านของคุณจะหมดอายุใน {0} วัน โปรดเปลี่ยนโดยเร็วที่สุด",
        "pwdExpiredDesc": "รหัสผ่านของคุณหมดอายุแล้ว โปรดตั้งรหัสผ่านใหม่",
        "noRight": "สิทธิ์ไม่เพียงพอ โปรดติดต่อผู้ดูแลระบบ",
        "browserSupport": "แนะนำให้ใช้เบราว์เซอร์ต่อไปนี้เพื่อเข้าถึง Huawei Cloud:",
        "browserSupport.chrome": "Google Chrome",
        "browserSupport.chromeVersion": "(36.0 หรือขึ้นไป)",
        "browserSupport.firefox": "Mozilla Firefox",
        "browserSupport.firefoxVersion": "(35.0 หรือขึ้นไป)",
        "browserSupport.ie": "Internet Explorer",
        "browserSupport.ieVersion": "(9.0 หรือขึ้นไป)",
        "countryCodeSelect": "โปรดเลือกรหัสประเทศ",
        "reactivate.reactivateAccount": "เปิดใช้งานบัญชี",
        "reactivate.pleaseCheckEmail": "บัญชีของคุณอยู่ระหว่างรอการเปิดใช้งาน ลงชื่อเข้าใช้ที่อยู่อีเมลที่ลงทะเบียนแล้วคลิกลิงก์ในอีเมลลงทะเบียนเพื่อเปิดใช้งานบัญชีของคุณ",
        "advertisement.txt": "ฟรีสำหรับการทดลองใช้ 100 ครั้งแรก",
        "advertisement.buttonTxt": "นำมาใช้",
        "fphone.changePhoneNum": "เปลี่ยนมายเลขโทรศัพท์",
        "fphone.changeSuccess": "เสร็จสิ้น",
        "fphone.registerEmail": "ที่อยู่อีเมล:",
        "fphone.registerEmailPH": "โปรดป้อนที่อยู่อีเมลล์ของคุณ",
        "fphone.emailVerifyCode": "รหัสยืนยันอีเมล:",
        "fphone.getVerifyCodeByEmail": "ส่งรหัสรหัสยืนยัน",
        "fphone.emailVerifyCodePH": "โปรดป้อนรหัสยืนยัน",
        "fphone.newPhoneNum": "มายเลขโทรศัพท์ใหม่:",
        "fphone.newPhoneNumPH": "โปรดป้อนหมายเลขโทรศัพท์ใหม่",
        "fphone.smsVerifyCode": "รหัสยืนยันทาง SMS:",
        "fphone.getVerifyCodeBySms": "ส่งรหัสรยืนยัน",
        "fphone.smsVerifyCodePH": "โปรดป้อนรหัสยืนยัน",
        "fphone.changePhoneSuccess": "เปลี่ยนมายเลขโทรศัพท์สำเร็จแล้ว",
        "fphone.newPhoneNumInfo": "มายเลขโทรศัพท์ใหม่:",
        "fphone.phoneRepeat": "มีการใช้หมายเลขโทรศัพท์นี้แล้ว",
        "fphone.exceedMaxAccounts": "ถึงจำนวนบัญชีสูงสุด (6) ที่สามารถผูกกับหมายเลขโทรศัพท์ได้แล้ว",
        "mobileNumber": "มายเลขโทรศัพท์:",
        "fphone.changeMobile": "เปลี่ยนมายเลขโทรศัพท์",
        "sendSmsIntervalErr": "พยายามรับรหัสยืนยันถึงจำนวนครั้งสูงสุดแล้ว โปรดลองอีกครั้งหลังจาก 1 นาที",
        "cookie.chromeDesc": "เลือกการตั้งค่า > แสดงการตั้งค่าขั้นสูง > ความเป็นส่วนตัว > การตั้งค่าเนื้อหา ยกเลิกการเลือก \"บล็อกคุกกี้และข้อมูลไซต์ของบุคคลที่สาม\" เลือก \"อนุญาตข้อมูลในเครื่อง (แนะนำ)\" แล้วคลิก เสร็จสิ้น จากนั้นรีสตาร์ทเบราว์เซอร์และเข้าสู่ระบบอีกครั้ง",
        "cookie.firefoxDesc": "เลือกตัวเลือก > ความเป็นส่วนตัว เลือกการตั้งค่าแบบกำหนดเองสำหรับประวัติ ยกเลิกการเลือก \"ใช้โหมดการเรียกดูแบบส่วนตัวเสมอ\" เลือก \"ยอมรับคุกกี้จากไซต์\" แล้วคลิกตกลง จากนั้น รีสตาร์ทเบราว์เซอร์และเข้าสู่ระบบอีกครั้ง",
        "cookie.ieDesc": "เลือก เครื่องมือ > ตัวเลือกอินเทอร์เน็ต > ความเป็นส่วนตัว ตั้งค่าโซนอินเทอร์เน็ตเป็น \"ยอมรับคุกกี้ทั้งหมด\" คลิก ใช้ แล้วคลิก ตกลง จากนั้นรีสตาร์ทเบราว์เซอร์และเข้าสู่ระบบอีกครั้ง",
        "cookie.chromeName": "Google Chrome:",
        "cookie.firefoxName": "Mozilla Firefox:",
        "cookie.ieName": "Internet Explorer:",
        "cookie.title": "ฉันจะเปิดใช้งานคุกกี้บนเบราว์เซอร์ของฉันได้อย่างไร",
        "cookie.loginTip": "คุณสามารถเข้าสู่ระบบได้หลังจากเปิดใช้งานคุกกี้",
        "cookie.startCookie": "เรียนรู้เพิ่มเติม",
        "verifyCode.intervalError": "พยายามรับรหัสยืนยันถึงจำนวนครั้งสูงสุดแล้ว โปรดลองอีกครั้งหลังจาก 1 นาที",
        "verifyCode.invalid": "รหัสยืนยันหมดอายุแล้ว คลิกส่งรหัสยืนยันเพื่อรับรหัสใหม่",
        "verifyCode.error": "รหัสยืนยันไม่ถูกต้อง โปรดป้อนรหัสยืนยันที่ถูกต้อง",
        "verifyCode.locked": "ฟังก์ชันรหัสยืนยันถูกล็อก โปรดลองอีกครั้งในวันพรุ่งนี้",
        "verifyCode.locked.custom": "ฟังก์ชันรหัสยืนยันถูกล็อก โปรดลองอีกครั้งในอีก {0} นาทีต่อมา หรือติดต่อฝ่ายบริการลูกค้าที่ 4000-955-988",
        "verifyCode.sendFailed": "การส่งรหัสยืนยันล้มเหลว โปรดคลิกส่งรหัสเพื่อรับรหัสใหม่",
        "verifyCode.remainderCount": "คุณเหลือความพยายามในการยืนยัน {0} ครั้ง หากความพยายามที่เหลือไม่สำเร็จ คุณจะต้องรอสักครู่ก่อนที่จะส่งรหัสอีกครั้ง",
        "verifyCode.cantAcquire": "ฟังก์ชันรหัสยืนยันถูกล็อคแล้ว โปรดป้อนรหัสยืนยันล่าสุดที่คุณได้รับ",
        "verifyCode.emailInvalidAndSMSError": "รหัสยืนยันทาง SMS ไม่ถูกต้อง โปรดลองอีกครั้งโดยใช้รหัสยืนยันอีเมลที่ถูกต้อง",
        "verifyCode.email.invalid": "รหัสยืนยันหมดอายุแล้ว โปรดคลิกส่งรหัสเพื่อรับรหัสใหม่",
        "verifyCode.email.error": "รหัสยืนยันไม่ถูกต้อง โปรดป้อนรหัสยืนยันที่ถูกต้อง",
        "verifyCode.sms.invalid": "รหัสยืนยันหมดอายุแล้ว โปรดคลิกส่งรหัสยืนยันเพื่อรับรหัสใหม่",
        "verifyCode.sms.error": "รหัสยืนยันไม่ถูกต้อง โปรดป้อนรหัสยืนยันที่ถูกต้อง",
        "verifyCode.usernameRepeat": "มีชื่อผู้ใช้นี้แล้ว โปรดป้อนชื่อผู้ใช้อื่น",
        "verifyCode.maxmiumSubUserNum": "จำนวนผู้ใช้ถึงขีดจำกัดสูงสุดที่อนุญาตแล้ว",
        "verifyCode.emailExist": "ที่อยู่อีเมลนี้มีอยู่แล้ว โปรดป้อนที่อยู่อีเมลอื่น",
        "loginVerification": "ยืนยันการเข้าสู่ระบบ",
        "loginVerification.tips": "ถ้าคุณไม่ต้องการให้แสดงข้อมูลที่กำหนดเองในระหว่างการเข้าสู่ระบบ โปรดติดต่อผู้ดูแลระบบ",
        "loginVerification.presetLoginInfo": "ข้อมูลกำหนดเองที่ตั้งไว้ล่วงหน้า",
        "loginVerification.warningInfo": "หากข้อมูลที่แสดงไม่ใช่ข้อมูลที่คุณกำหนดเอง โปรดยกเลิกการเข้าสู่ระบบ",
        "loginVerification.checkBySMS": "SMS",
        "loginVerification.SMSHasSentTo": " (รหัสยืนยันจะถูกส่งไปยังโทรศัพท์ของคุณ)",
        "loginVerification.pleaseClickAgain": " (หากไม่ได้รับรหัสยืนยันภายใน 60 วินาที โปรดคลิกส่งรหัสอีกครั้ง)",
        "loginVerification.userLoginInfo": "ข้อมูลเข้าสู่ระบบ",
        "loginVerification.lastSuccessTime": "การเข้าสู่ระบบสำเร็จครั้งล่าสุด",
        "loginVerification.lastFailedTime": "การเข้าสู่ระบบล้มเหลวครั้งล่าสุด",
        "loginVerification.failedTimes": "จำนวนการเข้าสู่ระบบล้มเหลว",
        "loginVerification.lockInfo": "บัญชีของคุณจะถูกล็อคเป็นเวลา {1} หากมีการพยายามเข้าสู่ระบบต่อเนื่องกันอีก {0} ครั้งไม่สำเร็จ",
        "loginVerification.lockInfo.hour": "{0} ชั่วโมง",
        "loginVerification.lockInfo.minute": "{0} นาที",

        "loginVerification.MFATitle": "อุปกรณ์ MFA เสมือน",
        "loginVerification.MFAContext": "โปรดป้อนรหัส 6 หลักที่ที่ได้รับจากแอปตรวจสอบความถูกต้อง",
        "loginVerification.MFAHelp": "เรียนรู้วิธีรับรหัสยืนยัน MFA",
        "loginVerification.MFALabel": "รหัสยืนยัน",
        "loginVerification.MFANotUseTip": "อุปกรณ์ MFA เสมือนไม่พร้อมใช้งานหรือ",
        "loginVerification.MFANotUseMessage1": "ติดต่อผู้ดูแลระบบของคุณเพื่อลบอุปกรณ์ MFA เสมือน",
        "loginVerification.MFANotUseMessage2": "ติดต่อฝ่ายบริการลูกค้าของ Huawei Cloud",
        "loginVerification.resetMFAHelpUrl": "<a href=\"{0}\" target=\"_blank\" rel=\"noopener noreferrer\">เรียนรู้วิธี</a>ในการเลิกผูกหรือนำอุปกรณ์ MFA เสมือนออก",
        "loginVerification.rememberMFALabel": "จำฉันได้ 7 วัน",
        "loginVerification.rememberMFALabel.disabledTip": "จำกัดผู้ใช้ IAM 5 รายต่อเบราว์เซอร์",
        "loginVerification.emailCheckTitle": "อีเมล",
        "loginVerification.emailCheckContent": " (รหัสยืนยันจะถูกส่งไปยัง {0})",
        "loginVerification.emailCodeLabel": "รหัสยืนยัน",
        "loginVerification.emailCodeTxt": "ส่งรหัสยืนยัน",
        "loginVerification.verificationType": "วิธีการตรวจสอบ",
        "loginVerification.verificationTypeForPhone": "การผูกหมายเลขโทรศัพท์และวิธีการตรวจสอบ",
        "loginVerification.verificationTypeForEmail": "ผูกที่อยู่อีเมลและวิธีการตรวจสอบ",
        "loginVerification.bindPhone": "มายเลขโทรศัพท์",
        "loginVerification.bindPhoneTips": "ผู้ดูแลระบบได้เปิดใช้งานการรับรองความถูกต้องทาง SMS โปรดป้อนหมายเลขโทรศัพท์",
        "loginVerification.bindPhonePH": "โปรดป้อนหมายเลขโทรศัพท์",
        "loginVerification.bindEmail": "ที่อยู่อีเมล",
        "loginVerification.bindEmailTips": "ผู้ดูแลระบบได้เปิดใช้งานการตรวจสอบโดยใช้อีเมล โปรดป้อนที่อยู่อีเมล",
        "loginVerification.bindEmailPH": "โปรดป้อนที่อยู่อีเมล",
        "loginVerification.verifyCode": "รหัสยืนยัน",
        "loginVerification.verifyCodeBtnTxt": "ส่งรหัสยืนยัน",
        "loginVerification.verifyCodePH": "รหัส 6 หลัก",
        "loginVerification.verifyCodeEmailPH": "รหัส 6 หลัก",
        "loginVerification.sendCodeTxt": "ส่งรหัสยืนยันแล้ว เพื่อรักษาความปลอดภัยของบัญชี โปรดอย่าแชร์รหัสนี้กับคนอื่น",
        "loginVerification.sendCodeFailed": "ไม่สามารถส่งรหัสยืนยันได้เนื่องจากระบบไม่ว่าง",
        "loginVerification.validEmailOrPhone": "ที่อยู่อีเมลหรือหมายเลขโทรศัพท์ไม่พร้อมใช้งาน",
        "loginVerification.retrieveTxt": "ส่งรหัสยืนยันอีกครั้ง ({0}วินาที)",
        "loginVerification.otherAccount": "ใช้บัญชีอื่น",
        "loginVerification.goOnLogin": "ตกลง",
        "loginVerification.title": "ผูกอุปกรณ์ MFA เสมือน",
        "loginVerification.firstStep": "ขั้นตอนที่ 1: สแกนรหัสคิวอาร์ต่อไปนี้เพื่อติดตั้งแอป Huawei Cloud หรือติดตั้งแอปยืนยันตัวตนอื่น",
        "loginVerification.firstStepIntroduction": "แอปตรวจสอบความถูกต้องจะแจ้งให้คุณเพิ่มบัญชีของคุณ",
        "loginVerification.secondStep": "ขั้นตอนที่ 2: ตั้งค่าแอป",
        "loginVerification.secondStepIntroduction": "เปิดแอปและสแกนรหัสคิวอาร์ต่อไปนี้หรือป้อนคีย์ลับ",
        "loginVerification.username": "ชื่อผู้ใช้",
        "loginVerification.domainname": "ชื่อบัญชี",
        "loginVerification.secretKey": "คีย์ลับ",
        "loginVerification.thirdStep": "ขั้นตอนที่ 3: ป้อนรหัสยืนยัน MFA",
        "loginVerification.thirdStepIntroduction": "โปรดป้อนรหัสยืนยัน MFA เสมือนสองชุดติดต่อกันที่ได้รับจากแอป",
        "loginVerification.firstRegCode": "รหัสยืนยัน 1",
        "loginVerification.secondRegCode": "รหัสยืนยัน 2",
        "loginVerification.submitText": "ตกลง",
        "loginVerification.bindMFASucceed": "ผูกอุปกรณ์ MFA เสมือนสำเร็จแล้ว",
        "loginVerification.mfaCodeError": "รหัสยืนยัน MFA ไม่ถูกต้อง โปรดป้อนรหัสที่ถูกต้อง",
        "loginVerification.mfaCodeLocked": "คุณขอรหัสยืนยันเกินจำนวนสูงสุดที่อนุญาต โปรดลองอีกครั้งหลังจาก 5 นาที",
        "bindAccount.title": "ผูกบัญชี Huawei Cloud",
        "bindAccount.submit": "ลงทะเบียนและผูก",
        "bindAccount.remindCompleteInfo": "กรอกข้อมูลต่อไปนี้เพื่อลงทะเบียนบัญชี Huawei Cloud และผูกบัญชี",
        "bindAccount.bindSuccess": "บัญชีที่ลงทะเบียนและผูกไว้สำเร็จแล้ว",
        "bindAccount.HWSAccount": "บัญชี Huawei Cloud ของคุณ:",
        "bindAccount.timeRemind": "หลังจาก {0} วินาที",
        "bindAccount.redirectPage": "กลับไปหน้าแรก",
        "validCountryCode": "เลือกรหัสประเทศ",
        "registerGift": "คุณสามารถรับคูปองเงินสดได้หลังจากลงทะเบียนสำเร็จ",
        "registerGiftAddress": "รับคูปองเงินสด",
        "registerGiftSuffixMobile": "รับคูปองเงินสด",
        "registerSuccess.goToGift": "ไปที่",
        "registerSuccess.goToGiftFillInfo": " เพื่อรับคูปองเงินสดพิเศษสำหรับผู้ใช้ใหม่",
        "welcomeLogin.titleDetail": "เพื่อรักษาความปลอดภัยของบัญชี โปรดตั้งรหัสผ่าน",
        "welcomeEmail.title": "อีเมลต้อนรับ",
        "welcomeEmail.linkTimeout": "ลิงก์หมดอายุแล้ว",
        "welcomeEmail.linkExpired": "ลิงก์ไม่พร้อมใช้งาน",
        "welcomeEmail.resendEmail": "ส่งอีเมลต้อนรับใหม่อีกครั้ง",
        "welcomeEmail.contactAdm": "ติดต่อผู้ดูแลระบบเพื่อส่งอีเมลต้อนรับอีกครั้ง",
        "welcomeEmail.alreadySend": "ส่งอีเมลต้อนรับแล้ว",
        "titles.setPassword": "Huawei Cloud - ตั้งรหัสผ่าน",
        "titles.welcomeEmail": "Huawei Cloud - อีเมลต้อนรับ",
        "welcomeEmail.setPassword": "ตั้งรหัสผ่าน",
        "dateFormate": "MMM dd, yyyy HH:mm:ss",
        "sessionExpired": "เซสชั่นของคุณหมดอายุแล้ว โปรดเข้าสู่ระบบอีกครั้ง",
        "m.userNamePlaceHolder": "ชื่อผู้ใช้ อีเมล หรือหมายเลขโทรศัพท์",
        "m.HongKongUserNamePlaceHolder": "ชื่อผู้ใช้หรืออีเมล",
        "m.accountNamePlaceHolder": "ชื่อบัญชีหรืออีเมล",
        "m.HongKongAccountNamePlaceHolder": "ชื่อบัญชีหรืออีเมล",
        "m.verifyCodePlaceHolder": "รหัสแคปต์ชา",
        "inValidCountryCode": "โปรดเลือกรหัสประเทศ",
        "mobile.CountryCode": "+86 (แผ่นดินใหญ่จีน)",
        "authenticationInfo": "ฟังก์ชันบางอย่างจะไม่สามารถใช้ได้สำหรับผู้ใช้ที่ยังไม่เสร็จสิ้นการตรวจสอบชื่อจริง",
        "authenticationForwardInfo": "โปรดยืนยันชื่อจริงเสร็จเรียบร้อยเพื่อประสบการณ์การบริการที่สมบูรณ์",
        "authenticationForward": "ยืนยันชื่อจริง",
        "registerSuccess.goToAuthentication": "เสร็จเรียบร้อย",
        "registerSuccess.authenticationInfo": "เพื่อรับแพ็กเกจทดลองใช้งานฟรี 6 เดือน",
        "fpwd.findByEmail": "การยืนยันที่อยู่อีเมล",
        "fpwd.findByPhone": "การยืนยันหมายเลขโทรศัพท์",
        "fpwd.accountNameByEmail": "ที่อยู่อีเมล:",
        "fpwd.accountNameByPhone": "มายเลขโทรศัพท์:",
        "fpwd.phoneAccountNamePH": "โปรดป้อนหมายเลขโทรศัพท์",
        "eChannelName": "Huawei Enterprise Partner",
        "uniportalName": "บัญชี Huawei",
        "moreLink": "เพิ่มเติม",
        "registerSuccess.authenticationForward": "ยืนยันชื่อจริง",
        "homepageLink": "หน้าแรก",
        "helpCenter": "เอกสารประกอบ",
        "cloudCommunity": "ชุมชนคลาวด์",
        "registerSuccess.goToUserZone": "ไปที่",
        "registerSuccess.userZoneLink": "โซนผู้ใช้ใหม่",
        "registerSuccess.userZoneInfo": " เพื่อรับแพ็กเกจส่วนลดพิเศษ 50%",
        "register.accountPlaceHolder": "ชื่อบัญชี",
        "register.passwordPlaceHolder": "รหัสผ่าน",
        "register.confirmPasswordPlaceHolder": "ยืนยันรหัสผ่าน",
        "register.phonePlaceHolder": "มายเลขโทรศัพท์",
        "register.msgCodePlaceHolder": "รหัสยืนยัน",
        "register.accountNameLength": "โปรดป้อน 5 ถึง 32 อักขระ",
        "register.bindACccountPlaceHolder": "ชื่อบัญชี อีเมล หรือหมายเลขโทรศัพท์",
        "remindBindEmail.title": "ผูกที่อยู่อีเมล",
        "remindBindEmail.remindMsg": "บัญชีของคุณไม่มีที่อยู่อีเมลที่ผูกไว้ โปรดผูกที่อยู่อีเมลเพื่อ:",
        "remindBindEmail.remindInfo1": "● รับการแจ้งเตือนที่สำคัญ เช่น การเปิด การหมดอายุ และการลบบริการคลาวด์",
        "remindBindEmail.remindInfo2": "● ยืนยันตัวตนของคุณเมื่อคุณดำเนินสิ่งที่สำคัญ เช่น การเปลี่ยนหมายเลขโทรศัพท์ การรีเซ็ตรหัสผ่าน และการลบ ECS",
        "remindBindEmail.bind": "ผูกมัดตอนนี้",
        "remindBindEmail.nextBind": "ภายหลัง",
        "remindBindEmail.remind": "โปรดทราบ",
        "remindBindEmail.remindHideInfo": "โปรดผูกที่อยู่อีเมลบนหน้าแท็บใหม่",
        "remindBindEmail.remindHideFailde": "หากการผูกล้มเหลว",
        "remindBindEmail.remindHideFailde2": "โปรดผูกที่อยู่อีเมลอื่น",
        "remindBindEmail.remindHideSuccess": "ผูกเสร็จ",
        "notify.openPage": "โปรดรอ...",
        "notify.closeSecondBefore": "การดำเนินการสำเร็จ",
        "notify.closePage": "การดำเนินการสำเร็จ กรุณาปิดเพจ",
        "registerFailed.accountNameRepeat": "มีบัญชีที่ใช้ชื่อเดียวกันนี้แล้ว",
        "register.bindAccountPlaceHolder": "ชื่อบัญชี อีเมล หรือหมายเลขโทรศัพท์",
        "privacyPolicyUpdate": "ปรับปรุงคำชี้แจงในการเก็บรวบรวมข้อมูลส่วนบุคคล",
        "privacyTipPre": "เรียนลูกค้า เราได้ปรับปรุงคำชี้แจงในการเก็บรวบรวมข้อมูลส่วนบุคคลของ Huawei Cloud เราเข้าใจถึงความสำคัญของความเป็นส่วนตัวของคุณและมุ่งมั่นที่จะปกป้องความเป็นส่วนตัวอย่างเต็มที่ โปรดอ่านการปรับปรุง",
        "privacyTipSuf": "อย่างรอบคอบเพื่อเรียนรู้วิธีที่เราปกป้องข้อมูลส่วนบุคคลของคุณ",
        "agreementBtnTxt": "ยอมรับ",
        "privacyAgreementNotAcceptedError": "โปรดคลิกช่องทำเครื่องหมายเพื่อยืนยันว่าคุณได้อ่านและยอมรับคำชี้แจงในการเก็บรวบรวมข้อมูลส่วนบุคคลของ Huawei Cloud",
        "OIDC.errorDefault": "เกิดข้อผิดพลาดของระบบ โปรดติดต่อผู้ดูแลระบบ",
        "OIDC.errorO001": "เกิดข้อผิดพลาดของระบบ โปรดลองอีกครั้ง",
        "OIDC.errorO002": "รหัสโดเมนไม่ถูกต้อง",
        "OIDC.errorO003": "ID ตัวให้บริการข้อมูลเอกลักษณ์ไม่ถูกต้อง",
        "OIDC.errorO004": "URL บริการไม่ถูกต้อง",
        "OIDC.errorO005": "ขออภัย ไม่พบการกำหนดค่า OpenId Connect ที่พร้อมใช้งาน",
        "OIDC.errorO006": "การกำหนดค่า OpenID ไม่ถูกต้อง",
        "OIDC.errorO007": "ID Token ไม่ถูกต้อง",
        "OIDC.errorO008": "พารามิเตอร์ State ไม่ถูกต้อง",
        "OIDC.errorO009": "JWT ไม่ถูกต้อง",
        "OIDC.errorO010": "การตรวจสอบ Acl ล้มเหลว",
        "OIDC.errorO011": "ขออภัย รับโทเค็น IAM ตามกฎการจับคู่ไม่สำเร็จ โปรดตรวจสอบกฎการจับคู่หรือติดต่อผู้ดูแลระบบ",
        "OIDC.errorO012": "ขออภัย ไม่มีโครงการที่เข้าถึงได้",
        "OIDC.errorO013": "มีคำร้องขอมากเกินไป โปรดลองอีกครั้งในภายหลัง",
        "OIDC.errorO014": "ไม่สามารถเข้าถึงคอนโซลในโหมดการเข้าถึงแบบ[เป็นโปรแกรม]",
        "OIDC.errorO015": "ข้อผิดพลาดที่ไม่ถูกต้อง",
        "console_term_dt_not_allowed": "เบราว์เซอร์ได้ตรวจพบว่ากำลังเปิดสัญญาอื่น สัญญานี้จะถูกปิด",
        "console_term_dt_count_down": "หน้านี้จะปิดใน {0} วินาที",
        "console_term_dt_browser_prevent_close": "การกำหนดค่าเบราว์เซอร์ของคุณไม่อนุญาตให้ระบบปิดหน้าโดยอัตโนมัติ",
        "console_term_dt_not_sync": "ขออภัย บริการ Open Telekom Cloud ของคุณไม่พร้อมใช้งาน โปรดติดต่อผู้ดูแลระบบ",
        "console_term_dt_error_code": "รหัสสถานะ: {0}",
        "console_term_dt_not_refresh": "อย่ารีเฟรชหรือเปิดหน้าปัจจุบันโดยตรง",
        "console_term_dt_aclCheck_failed": "คุณไม่ได้รับอนุญาตให้เข้าสู่ระบบจากเครื่องเทอร์มินัลนี้",
        "console_term_dt_tenent_md_error1": "รูปแบบของไฟล์ข้อมูลอภิพันธุ์ที่อัพโหลดโดยตัวให้บริการข้อมูลเอกลักษณ์ที่ระบุไม่ถูกต้อง",
        "console_term_dt_tenent_md_error2": "โปรดติดต่อผู้ดูแลระบบเพื่ออัปโหลดไฟล์ข้อมูลอภิพันธุ์บนหน้าการตั้งค่าของตัวให้บริการข้อมูลเอกลักษณ์ที่เกี่ยวข้อง และลองอีกครั้ง",
        "console_term_dt_tenent_md_unexisted1": "ไม่มีข้อมูลเอกลักษณ์ของตัวให้บริการที่ระบุไว้หรือไม่ได้อัปโหลดไฟล์ข้อมูลอภิพันธุ์",
        "console_term_dt_tenent_md_unexisted2": "ติดต่อผู้ดูแลระบบเพื่ออัปโหลดไฟล์ข้อมูลเมตาบนหน้าการตั้งค่าผู้ให้บริการข้อมูลเอกลักษณ์ที่เกี่ยวข้อง แล้วลองอีกครั้ง",
        "console_term_dt_tenent_rule_error": "ไม่สามารถแมปพร็อพเพอร์ตี้บัญชีผู้ใช้ของพันธมิตรองค์กรกับค่าข้อมูลเอกลักษณ์ ตรวจสอบกฎการแปลงในหน้าการตั้งค่าผู้ให้บริการข้อมูลเอกลักษณ์และตรวจสอบว่าได้เปิดใช้ตัวให้บริการข้อมูลเอกลักษณ์ที่ตรงกันแล้ว",
        "console_term_dt_tenent_untrusted": "ที่อยู่ที่จะนำไปใน URL ไม่อยู่ในรายการใบรับรองที่น่าเชื่อถือของระบบ",
        "console_term_dt_tenent_url_error": "พบพารามิเตอร์ที่ไม่ถูกต้องใน URL ของคุณ โปรดยืนยัน URL ของคุณ",
        "console_saml_response_timeout": "หมดเวลาการทำงาน โปรดเข้าสู่ระบบอีกครั้ง",
        "console_saml_login_link_tip": "URL:",
        "console_saml_verify_signature_failed": "การตรวจสอบลายเซ็นล้มเหลว โปรดตรวจสอบใบรับรองลายเซ็นของคุณ",
        "console_term_dt_no_inResponseTo_in_response": "การตอบกลับการตรวจสอบสิทธิ์ที่ส่งคืนโดย IdP ขาดแอตทริบิวต์ InResponseTo",
        "console_term_dt_question_tip": "คุณสามารถตรวจสอบปัญหาโดยใช้วิธีการต่อไปนี้:",
        "console_term_dt_inResponseTo_reason": "เหตุใดจึงต้องมีแอตทริบิวต์ InResponseTo",
        "console_term_dt_inResponseTo_reason_content": "เพื่อป้องกันการโจมตีแบบเล่นซ้ำ โปรโตคอล SAML2.0 กำหนดว่าในโฟลว์ SSO ที่เริ่มต้นโดย SP (ซึ่ง SP ส่ง AuthRequest ไปยัง IdP) การตอบสนองและการยืนยัน IdP ต้องมีแอตทริบิวต์ InResponseTo และค่าของ InResponseTo จะต้องเหมือนกันกับ ID ของ AuthRequest ที่เริ่มต้นโดย SP",
        "console_term_dt_inResponseTo_check": "วิธีการตรวจสอบการตอบกลับมีแอตทริบิวต์ InResponseTo หรือไม่",
        "console_term_500Error_label": "ระบบไม่ว่าง โปรดลองอีกครั้งในภายหลัง",
        "console_term_404Error_label": "ขออภัย ไม่พบหน้านี้",
        "console_term_401Error_label": "ขออภัย หน้าหมดอายุแล้ว",
        "titles.loginReminder": "Huawei Cloud - เข้าสู่ระบบ",
        
        "OIDC.errorE0001": "ไม่มีข้อมูลบัญชีหรือผู้ใช้ โปรดตรวจสอบการตั้งค่าของคุณแล้วลองอีกครั้ง",
        "OIDC.errorE0002": "ไม่มีข้อมูลข้อมูลบัญชี โปรดตรวจสอบการตั้งค่าของคุณแล้วลองอีกครั้ง",
        "OIDC.errorE0003": "ไม่มีข้อมูลผู้ใช้ โปรดตรวจสอบการตั้งค่าของคุณแล้วลองอีกครั้ง",
        "OIDC.errorE0004": "ไม่มีข้อมูลในการยืนยัน โปรดตรวจสอบการตั้งค่าของคุณแล้วลองอีกครั้ง",
        "OIDC.errorE0005": "ไม่มีข้อมูลบัญชี โปรดตรวจสอบการตั้งค่าของคุณแล้วลองอีกครั้ง",
        "OIDC.errorE0009": "การตรวจสอบลายเซ็นล้มเหลว โปรดตรวจสอบการตั้งค่าของคุณแล้วลองอีกครั้ง",
        "OIDC.errorE0010": "โปรดอย่ารีเฟรชหรือเปิดหน้าเว็บนี้",
        "OIDC.errorE0011": "ไม่พบนโยบาย ACL โปรดติดต่อผู้ดูแลระบบแล้วลองอีกครั้ง",
        "OIDC.errorE0012": "การตรวจสอบ ACL ล้มเหลว โปรดติดต่อผู้ดูแลระบบแล้วลองอีกครั้ง",
        "OIDC.errorE0013": "ผู้ใช้ถูกปิดการใช้งาน โปรดติดต่อผู้ดูแลระบบแล้วลองอีกครั้ง",
        "OIDC.errorE0014": "ระบบผิดพลาด โปรดตรวจสอบใบรับรองจากผู้ให้บริการข้อมูลระบุตัวตน",
        "OIDC.errorE0015": "ไม่สามารถจับคู่ ID ผู้ใช้ในการยืนยัน โปรดตรวจสอบการตั้งค่าของคุณแล้วลองอีกครั้ง",
        "OIDC.errorE0018": "บัญชีไม่ได้ซิงค์ โปรดติดต่อผู้ดูแลระบบ",
        "OIDC.errorE0019": "ข้อมูลเซสชันผิดปกติ โปรดล้างคุกกี้แล้วลองอีกครั้ง",
        "OIDC.errorE0020": "รหัสเซสชันไม่ตรงกัน อาจมีการเริ่มต้นหลายเซสชันพร้อมกัน โปรดล้างคุกกี้แล้วลองอีกครั้ง",
        "OIDC.errorE0021": "ล้มเหลวในการจับคู่ Recipient และ Destination กับ ACS โปรดตรวจสอบการตั้งค่าของคุณแล้วลองอีกครั้ง",
        "OIDC.errorE0022": "รหัสสถานะใน SAMLResponse ผิดปกติ โปรดแก้ไขข้อบกพร่องของผู้ให้บริการข้อมูลประจำตัว",
        "OIDC.errorE0023": "ไม่มีการยืนยันใด ๆ โปรดตรวจสอบการตั้งค่าผู้ให้บริการข้อมูลประจำตัวแล้วลองอีกครั้ง",
        "OIDC.errorE0026": "รูปแบบการยืนยันไม่สอดคล้องกับโปรโตคอล SAML 2.0 โปรดตรวจสอบการตั้งค่าของคุณแล้วลองอีกครั้ง",
        "OIDC.errorE0027": "ไม่มี AuthnStatement ในการยืนยัน โปรดตรวจสอบการตั้งค่าของคุณแล้วลองอีกครั้ง",
        "OIDC.errorE0028": "การยืนยันหมดอายุแล้ว กรุณาเข้าสู่ระบบอีกครั้ง",
        "OIDC.errorE0029": "มีการใช้คำยืนยันแล้ว กรุณาเข้าสู่ระบบอีกครั้ง",
        "OIDC.errorE0030": "ไม่พบเอนทิตี IdP โปรดตรวจสอบการตั้งค่าของคุณแล้วลองอีกครั้ง",
        "OIDC.errorE0031": "ไม่สามารถรับใบรับรองผู้ให้บริการข้อมูลประจำตัว โปรดตรวจสอบการตั้งค่าของคุณแล้วลองอีกครั้ง",
        "OIDC.errorE0032": "หลีกเลี่ยงการเข้าสู่ระบบหลายเซสชันพร้อมกัน",
        "OIDC.errorE0033": "เมื่อลงชื่อเข้าใช้ด้วย IdP-initiated ไม่สามารถรวม InResponseTo ในคํายืนยัน โปรดตรวจสอบการตั้งค่าของคุณแล้วลองอีกครั้ง",
        "OIDC.errorE0034": "ไม่มี InResponseTo ในการยืนยัน โปรดตรวจสอบการตั้งค่าของคุณแล้วลองอีกครั้ง",
        "OIDC.errorE0035": "ไม่มี NotOnOrAfter ในการยืนยัน โปรดตรวจสอบการตั้งค่าของคุณแล้วลองอีกครั้ง",
        "OIDC.errorE0036": "ไม่มี Recipient ในการยืนยัน โปรดตรวจสอบการตั้งค่าของคุณแล้วลองอีกครั้ง",
        "OIDC.errorE0037": "ไม่รองรับการทำงานร่วมกับ SAML ที่ระบุ โปรดตรวจสอบพารามิเตอร์แล้วลองอีกครั้ง",
        "OIDC.errorE0039": "ไม่พบผู้ใช้หรือถูกปิดใช้งาน โปรดติดต่อผู้ดูแลระบบแล้วลองอีกครั้ง",
        "OIDC.errorE0040": "ไม่พบเซสชัน SAML ที่ถูกต้อง โปรดล้างคุกกี้แล้วลองอีกครั้ง",
        "OIDC.errorE0041": "ไม่มี SAMLResponse ที่ใช้ได้ โปรดตรวจสอบการกำหนดค่า IdP แล้วลองอีกครั้ง",
        "OIDC.errorE0050": "ระบบไม่ว่าง โปรดตรวจสอบการตั้งค่าของคุณแล้วลองอีกครั้ง",
            
        "OIDC.errorT0001": "ไม่พบ Metadata สำหรับผู้ให้บริการข้อมูลประจำตัว โปรดตรวจสอบการตั้งค่าของคุณแล้วลองอีกครั้ง",
        "OIDC.errorT0003": "รูปแบบ Metadata ไม่ถูกต้อง โปรดตรวจสอบการตั้งค่าของคุณแล้วลองอีกครั้ง",
        "OIDC.errorT0004": "การใช้กฎการแมปข้อมูลประจําตัวล้มเหลว โปรดตรวจสอบการตั้งค่าของคุณแล้วลองอีกครั้ง",
        "OIDC.errorT0005": "URL ไม่ถูกต้อง โปรดตรวจสอบการตั้งค่าของคุณแล้วลองอีกครั้ง",
        "OIDC.errorT0006": "พารามิเตอร์คำขอไม่ถูกต้อง โปรดตรวจสอบการตั้งค่าของคุณแล้วลองอีกครั้ง",
        "OIDC.errorT0008": "ไม่รองรับโหมดการเข้าถึง โปรดตรวจสอบการตั้งค่าโหมดการเข้าถึงผู้ใช้",

        "bodyValidateFailed": "คำขอตรวจสอบร่างกายล้มเหลว",
        "systemError": "ระบบผิดพลาด",
        "QRLogin.title1": "เข้าสู่ระบบด้วยรหัสคิวอาร์",
        "QRLogin.title2": "เข้าสู่ระบบ Huawei Cloud",
        "QRLogin.countDownTipPre1": "โปรดใช้",
        "QRLogin.countDownTipPre2": "แอป Huawei Cloud",
        "QRLogin.countDownTipPre3": " เพื่อสแกนรหัสคิวอาร์เพื่อเข้าสู่ระบบ",
        "QRLogin.remainingTime": "{0} วินาที",
        "QRLogin.countDownTipSuffix": "รหัสคิวอาร์จะหมดอายุหลังจาก",
        "QRLogin.QRCodeInvalid": "รหัสคิวอาร์หมดอายุแล้ว",
        "QRLogin.refresh": "รีเฟรช",
        "QRLogin.scanSuc": "สแกนสำเร็จแล้ว",
        "QRLogin.scanSucTip": "โปรดปฏิบัติตามคำแนะนำเพื่อยืนยันการเข้าสู่ระบบบนโทรศัพท์ของคุณ",
        "QRLogin.loginFail": "เข้าสู่ระบบล้มเหลว",
        "QRLogin.loginFailTipPre": "โปรดคลิก",
        "QRLogin.loginFailTipSuffix": " และสแกนรหัสคิวอาร์อีกครั้งเพื่อเข้าสู่ระบบ",
        "QRLogin.downloadApp": "ดาวน์โหลดแอป Huawei Cloud",
        "QRLogin.comma": ",",
        "QRLogin.loginReminder": "ตัวเตือนการเข้าสู่ระบบ",
        "QRLogin.accountLogin": "เข้าสู่ระบบด้วยรหัสผ่าน",
        "QRLogin.clientIpInvalid": "คุณไม่ได้รับอนุญาตให้เข้าสู่ระบบจากอุปกรณ์นี้เนื่องจากกฎการควบคุมการเข้าถึงที่กำหนดโดยผู้ดูแลระบบ",
        "hwId.cookieMsg": "เราใช้คุกกี้เพื่อปรับปรุงประสบการณ์การท่องเว็บของคุณ การเรียกดูไซต์ของเราต่อ แสดงว่าคุณยอมรับนโยบายคุกกี้ของเรา",
        "hwId.hwAccount": "HUAWEI ID",
        "hwId.privacyContent": "ข้อมูลบัญชีและเครือข่ายของคุณจะถูกใช้เพื่อช่วยปรับปรุงประสบการณ์การเข้าสู่ระบบของคุณ",
        "hwId.hwportal": "บัญชีเว็บไซต์ Huawei",
        "hwId.eChannel": "Huawei Enterprise Partner",
        "hwId.casLogin.systemError": "เกิดข้อผิดพลาด",
        "hwId.casLogin.systemErrorDesc": "เกิดข้อผิดพลาดของระบบ โปรดรีเฟรชเพจหรือติดต่อฝ่ายบริการลูกค้าที่ +86 4000 955 988 (แผ่นดินใหญ่จีน) หรือ +852 800 931 122 (ฮ่องกง จีน)",
        "hwId.casLogin.accountError": "เกิดข้อผิดพลาด",
        "hwId.casLogin.accountErrorDesc": "บัญชีของคุณไม่สามารถใช้เพื่อเข้าสู่ระบบ Huawei Cloud ได้ โปรดเข้าสู่ระบบด้วยบัญชีอื่น",
        "hwId.casLogin.accountErrorLink": "เรียนรู้เพิ่มเติม",
        "hwId.casLogin.accountErrorUrl": "/en-us/iam_faq/iam_01_0006.html",
        "hwId.casLogin.loginError": "เกิดข้อผิดพลาด",
        "hwId.casLogin.loginErrorDesc": "บัญชีของคุณไม่เหมาะกับวิธีการเข้าสู่ระบบปัจจุบัน โปรดเข้าสู่ระบบด้วย HUAWEI ID",
        "hwId.casLogin.accountExternalErrorDesc": "บัญชีปัจจุบันของคุณลงทะเบียนใน [ยุโรปหรือรัสเซีย] Huawei Cloud ไม่รองรับบัญชีในภูมิภาคดังกล่าวในขณะนี้ โปรดเข้าสู่ระบบด้วยบัญชีในภูมิภาคอื่น",
        "hwId.casLogin.accountExternalErrorLink": "เรียนรู้เพิ่มเติม",
        "hwId.casLogin.accountTurkeyErrorLink": "บัญชีปัจจุบันของคุณลงทะเบียนใน [ตุรกี] Huawei Cloud ไม่รองรับบัญชีในตุรกี โปรด <a href=\"{0}\" target=\"_blank\" rel=\"noopener noreferrer\">ลงทะเบียนสำหรับบัญชี Huawei Cloud</a > ทันทีหรือเข้าสู่ระบบด้วยบัญชีในภูมิภาคอื่น",
        "hwId.casLogin.inactivatedError": "บัญชีที่ไม่ใช้งาน",
        "hwId.casLogin.inactivatedErrorDesc": "บัญชีของคุณยังไม่ได้เปิดใช้งาน ระบบได้ส่งอีเมลเปิดใช้งานไปยังที่อยู่อีเมลที่คุณลงทะเบียนไว้โดยอัตโนมัติ โปรดไปที่และคลิกลิงก์ในที่อยู่อีเมลเพื่อเปิดใช้งานให้เสร็จสิ้นภายใน 24 ชั่วโมง",
        "hwId.casLogin.inactivatedErrorDesc.noEmail": "บัญชีของคุณไม่ได้เปิดใช้งานและไม่มีที่อยู่อีเมล บริการ Huawei Cloud ไม่สามารถใช้งานได้ชั่วคราว โปรดเปลี่ยนเป็นบัญชีอื่นและเข้าสู่ระบบอีกครั้ง",
        "hwId.casLogin.inactivatedHwidError": "บริการ Huawei Cloud ที่ไม่ได้ใช้งาน",
        "hwId.casLogin.inactivatedHwidErrorDesc": "บริการ Huawei Cloud ของคุณยังไม่ได้เปิดใช้งาน และระบบได้ส่งอีเมลเปิดใช้งานไปยังที่อยู่อีเมลที่คุณลงทะเบียนไว้โดยอัตโนมัติ โปรดไปที่ และคลิกลิงก์ในที่อยู่อีเมลเพื่อเปิดใช้งานบริการภายใน 24 ชั่วโมง",
        "hwId.casLogin.inactivatedHwidErrorDesc.noEmail": "บริการ Huawei Cloud ของคุณยังไม่ได้เปิดใช้งานและคุณไม่ได้ระบุที่อยู่อีเมล จึงไม่สามารถใช้บริการ Huawei Cloud ได้ชั่วคราว โปรดเปลี่ยนเป็นบัญชีอื่นและเข้าสู่ระบบอีกครั้ง",
        "hwId.casLogin.accessErrorDesc": "Huawei Cloud ไม่มีสิทธิ์ในการรับข้อมูลของบัญชีปัจจุบันของคุณ การเข้าสู่ระบบบัญชีนี้ไม่ได้รับการสนับสนุนชั่วคราว โปรดเข้าสู่ระบบด้วยบัญชีอื่น",
        "hwId.refresh": "รีเฟรช",
        "hwId.cookies": "คุ้กกี้",
        "hwId.otherAccount": "ใช้บัญชีอื่น:",
        "hwId.otherAccount.h5": "ใช้บัญชีอื่น",
        "hwId.hwIdLogin": "เข้าสู่ระบบบัญชี Huawei",
        "hwId.accountPlaceHolder": "ชื่อผู้เช่าหรือชื่อบัญชี Huawei Cloud",
        "fpwd.accountFpwdTitle": "รีเซ็ตรหัสผ่านบัญชี Huawei Cloud",
        "fpwd.iamFpwdTitle": "รีเซ็ตรหัสผ่านผู้ใช้ IAM",
        "fpwd.goAccountFpwd": "รีเซ็ตรหัสผ่านบัญชี Huawei Cloud",
        "fpwd.goIAMFpwd": "รีเซ็ตรหัสผ่านผู้ใช้ IAM",
        "fpwd.step2.accountHelpMsg": "หากคุณไม่สามารถทำการยืนยันโดยใช้โทรศัพท์มือถือและบัญชีอีเมลของคุณได้ โปรดโทร +86 4000 955 988 (แผ่นดินใหญ่จีน) หรือ +852 800 931 122 (ฮ่องกง จีน) หากคุณได้รับรหัสผ่านแล้ว ให้ไปที่หน้าเข้าสู่ระบบ และเข้าสู่ระบบ",
        "fpwd.step2.switchPhoneVerify": "การยืนยันหมายเลขโทรศัพท์",
        "fpwd.step2.switchEmailVerify": "การยืนยันที่อยู่อีเมล",
        "fpwd.pwdValidateRule": "ข้อกำหนดรหัสผ่าน:",
        "fpwd.pwdSafetyDegree": "ความรัดกุมของรหัสผ่าน:",
        "fpwd.selectUserTitle": "เลือกชื่อบัญชี",
        "fpwd.step1.fpwdByEmail": "การยืนยันชื่อผู้เช่า/ที่อยู่อีเมล",
        "fpwd.step1.fpwdByPhone": "การยืนยันหมายเลขโทรศัพท์",
        "fpwd.step1.phoneAccountNamePH": "มายเลขโทรศัพท์",
        "fpwd.verifyCodePlaceHolder": "รหัสแคปต์ชา",
        "fpwd.accountOrEmailPH": "ชื่อบัญชีหรือที่อยู่อีเมล",
        "fpwd.IAMAccountPH": "ชื่อบัญชีแอดมิน",
        "fpwd.IAMAccountNamePHNew": "ชื่อผู้ใช้ IAM หรือที่อยู่อีเมล",
        "fpwd.step2.sendVerificationCode": "ส่งรหัสยืนยัน",
        "fpwd.confirmPasswdPH": "ป้อนรหัสผ่านใหม่อีกครั้ง",
        "fpwd.accountOrEmailPH.h5": "ชื่อบัญชีหรือที่อยู่อีเมล",
        "fpwd.step1.phoneAccountNamePH.h5": "มายเลขโทรศัพท์",
        "fpwd.IAMAccountPH.h5": "ชื่อผู้เช่าหรือชื่อบัญชี Huawei Cloud",
        "fpwd.IAMAccountNamePHNew.h5": "ชื่อผู้ใช้ IAM หรือที่อยู่อีเมล",
        "fpwd.verifyCodePlaceHolder.h5": "รหัสแคปต์ชา",
        "fpwd.newPasswdPH.h5": "ป้อนรหัสผ่านใหม่",
        "fpwd.confirmPasswdPH.h5": "ป้อนรหัสผ่านใหม่อีกครั้ง",
        "fpwd.iamFpwdAccountError": "โปรดป้อนชื่อผู้ใช้ IAM ที่ถูกต้อง",
        "hwId.upgradeTitle": "อัปเกรดเป็น HUAWEI ID และเข้าถึงบริการทั้งหมดของ Huawei",
        "hwId.upgradeDesc": "คุณเข้าสู่ระบบด้วยบัญชี Huawei Cloud ซึ่งใช้สำหรับบริการ Huawei Cloud เท่านั้น อัปเกรดบัญชีของคุณเป็น HUAWEI ID เพื่อเข้าถึงบริการต่าง ๆ ของ Huawei อย่างเต็มรูปแบบ รวมถึง HUAWEI Developers, อุปกรณ์ HUAWEI (เช่น โทรศัพท์ HUAWEI), Huawei Mobile Services (เช่น HUAWEI Mobile Cloud และ HUAWEI Video) หลังจากอัปเกรด คุณจะสามารถใช้ HUAWEI ID ของคุณสำหรับทรัพยากร Huawei Cloud ทั้งหมดของคุณได้เช่นกัน",
        "hwId.upgradeDescLink": "เรียนรู้เพิ่มเติม",
        "hwId.upgradeSuggest": "หากบัญชี Huawei Cloud ของคุณใช้สำหรับธุรกิจ ขอแนะนำให้คุณเลือกอัปเกรดด้วย HUAWEI ID ใหม่ ",
        "hwId.upgradeAgreements.pre": "ฉันเข้าใจว่า HUAWEI ID รวบรวมชื่อบัญชี หมายเลขโทรศัพท์เคลื่อนที่ ที่อยู่อีเมล ประเทศ/ภูมิภาคที่ลงทะเบียน และข้อมูลรับรองการเข้าสู่ระบบของฉัน และฉันได้อ่านและตกลงที่จะ",
        "hwId.upgradeAgreements.userAgreement": " ข้อตกลงผู้ใช้ HUAWEI ID",
        "hwId.upgradeAgreements.and": " และ",
        "hwId.upgradeAgreements.privacyPolicy": " คำชี้แจงเกี่ยวกับ HUAWEI ID และความเป็นส่วนตัว",
        "hwId.upgradeBtnTxt": "อัพเกรดตอนนี้",
        "hwId.upgradeCancelBtnTxt": "อัพเกรดภายหลัง",
        "hwId.upgradePageTitle": "อัปเกรดบัญชี - Huawei Cloud",
        "hwId.upgradeGoBack": "อัปเกรดบัญชี",
        "hwId.upgradeErrorTitle": "โหลดไม่สำเร็จ",
        "hwId.upgradeErrorDesc": "บริการผิดพลาด โปรดติดต่อฝ่ายบริการลูกค้า",
        "hwId.upgradeErrorBtn": "ตกลง",
        "hwId.forgetPwd": "ลืมรหัสผ่าน",
        "hwId.hwCloudAccount": "บัญชี Huawei Cloud",
        "hwId.hwCloudAccountLogin": "เข้าสู้ระบบบัญชี",
        "quickLogin.title": "เข้าสู่ระบบด่วน",
        "quickLogin.loginTip": "เข้าสู่ระบบผ่านทาง SMS หรือยืนยันอีเมล",
        "quickLogin.accountInputPH": "มายเลขโทรศัพท์ อีเมล หรือชื่อบัญชี",
        "quickLogin.smsCodePH": "รหัสยืนยัน",
        "quickLogin.emailCodePH": "รหัสยืนยัน",
        "quickLogin.codeBtn": "ส่งรหัสยืนยัน",
        "quickLogin.codeCountdown": "ส่งรหัสยืนยันอีกครั้ง ({0}วินาที)",
        "quickLogin.mobileLogin": "การยืนยันหมายเลขโทรศัพท์",
        "quickLogin.emailLogin": "การยืนยันที่อยู่อีเมล",
        "quickLogin.selectUsersTitle": "เลือกบัญชี",
        "quickLogin.selectUsersTitle.h5": "เลือกบัญชี",
        "quickLogin.notAllowed": "บัญชีนี้ไม่รองรับการเข้าสู่ระบบด่วน เปลี่ยนใช้บัญชีอื่น",
        "quickLogin.smsCodeMsg": "ส่งรหัสยืนยันไปที่หมายเลขโทรศัพท์ของคุณ {0}",
        "quickLogin.emailCodeMsg": "ส่งรหัสยืนยันไปยังที่อยู่อีเมลของคุณ {0}",
        "quickLogin.noMobile": "บัญชีนี้ไม่ได้พูกกับหมายเลขโทรศัพท์ เข้าสู่ระบบโดยใช้ที่อยู่อีเมล",
        "quickLogin.noEmail": "บัญชีนี้ไม่ได้พูกกับที่อยู่อีเมล เข้าสู่ระบบโดยใช้หมายเลขโทรศัพท์",
        "quickLogin.qucikLoginTip": "บัญชีนี้ได้รับการอัปเกรดเป็น HUAWEI ID แล้ว เข้าสู่ระบบผ่านหน้าเข้าสู่ระบบ HUAWEI ID",
        "quickLogin.notActivate": "บัญชีนี้ยังไม่ได้เปิดใช้งาน จะไม่รองรับการเข้าสู่ระบบด่วน",
        "quickLogin.register": "ลงทะเบียนฟรี",
        "quickLogin.EnterCorrectEnterpriseAccount": "โปรดป้อนชื่อบัญชีที่ลงทะเบียนกับ Huawei Cloud",
        "ssologin.title": "เลือกตัวให้บริการข้อมูลเอกลักษณ์",
        "ssologin.btnTxt": "เข้าถึงเลย",
        "idpLogin.loginLink": "บัญชีผู้ใช้ของพันธมิตรองค์กร",
        "idpLogin.title": "เข้าสู่ระบบด้วยผู้ใช้บัญชีพันธมิตรองค์กร",
        "idpLogin.h5SelectTip": "เลือกตัวให้บริการข้อมูลเอกลักษณ์",
        "idpLogin.accountPh": "ชื่อบัญชี Huawei Cloud หรือชื่อผู้เช่า",
        "idpLogin.listPh": "ตัวให้บริการข้อมูลเอกลักษณ์",
        "idpLogin.goLogin": "เข้าสู่ระบบ",
        "idpLogin.goAccountLogin": "บัญชี Huawei Cloud",
        "idpLogin.noIdps": "บัญชีนี้ไม่เชื่อมโยงกับตัวให้บริการข้อมูลเอกลักษณ์ใด ๆ โปรดป้อนชื่อบัญชีอื่นหรือชื่อผู้เช่า",
        "idpLogin.domainNotExist": "ไม่มีบัญชีนี้ โปรดป้อนชื่อบัญชีอื่นหรือชื่อผู้เช่า",
        "selfManage.alertTip": "ผู้ดูแลระบบได้ปิดใช้งานการจัดการข้อมูลด้วยตนเอง หากคุณต้องการแก้ไขข้อมูลของคุณ โปรดติดต่อผู้ดูแลระบบ",
        "error.L0003": "บัญชีนี้รองรับการเข้าถึงแบบเป็นโปรแกรมเท่านั้นและไม่สามารถเข้าสู่ระบบคอนโซลได้ โปรดใช้ API, CLI หรือ SDK เพื่อเข้าถึง",
        "userNotExist": "ไม่มีผู้ใช้รายนี้ ติดต่อผู้ดูแลระบบ",
    
        "agreementUpdateTitle": `${BRAND} Customer Agreement Update	`,
        "agreementTip": `${BRAND} has updated ${BRAND} Customer Agreement in accordance with relevant laws and regulations. You can learn about <a href='{0}' target='_blank' rel='noopener noreferrer'>update details</a> and view the latest <a href='{1}' target='_blank' rel='noopener noreferrer'>${BRAND} Customer Agreement</a>. `,

        "privacyUpdateTitle": "Privacy Statement Update",
        "privacyTip": `${BRAND} has updated Privacy Statement in accordance with relevant laws and regulations. You can learn about <a href='{0}' target='_blank' rel='noopener noreferrer'>update details</a> and view the latest <a href='{1}' target='_blank' rel='noopener noreferrer'>Privacy Statement</a>. `,

        "agreementAndPrivacyUpdateTitle": `${BRAND} Customer Agreement and Privacy Statement Update`,
        "agreementAndPrivacyTip": `${BRAND} has updated ${BRAND} Customer Agreement and Privacy Statement in accordance with relevant laws and regulations. You can learn about <a href='{0}' target='_blank' rel='noopener noreferrer'>update details<a> and view the latest <a href='{1}' target='_blank' rel='noopener noreferrer'>${BRAND} Customer Agreement</a> and <a href='{2}' target='_blank' rel='noopener noreferrer'>Privacy Statement</a>.`,
  }

    function i18n(key) {
        return i18n.framework[key];
    }
    i18n.framework = framework;
    return i18n;
});



// WEBPACK FOOTER //
// ./public/hws/i18n/th-th/resource.js